<template>
  <div class="subsection" ref="subsection">
    <!-- 音频文件：播放器 + html_result -->
    <div class="subsectionLeft" v-if="isAudioFile">
      <div class="audioContainer">
        <div class="audioPlayer">
          <audio :src="decodedAudioSrc" controls controlsList="nodownload" preload="metadata">
            您的浏览器不支持音频播放
          </audio>
        </div>
        <div class="audioContent">
          <doc-view
              ref="docView"
              :html_result="html_result"
              :split_paragraphs="split_paragraphs"
              :fileSuffix="fileSuffix"
              @selectDiv="selectDiv">
          </doc-view>
        </div>
      </div>
    </div>
    <!-- 普通文档文件 -->
    <div class="subsectionLeft" v-else-if="['doc','docx','txt','html','md','png','jpg','jpeg','gif','bmp','webp','svg','feishuhtml'].includes(fileSuffix)">
      <doc-view
          ref="docView"
          :html_result="html_result"
          :split_paragraphs="split_paragraphs"
          :fileSuffix="fileSuffix"
          @selectDiv="selectDiv">
      </doc-view>
    </div>
    <!-- PDF文件 -->
    <pdf-view ref="pdfView" class="subsectionPdfLeft" id="subsectionLeft" :split_paragraphs="split_paragraphs" :ossPath="ossPath" v-else-if="fileSuffix === 'pdf'"></pdf-view>
    <div class="subsectionRight" @dragover="handleDragOver($event)">
      <template v-if="!loadingSplit">
        <div class="rightHeader">
          <el-tabs v-model="activeTab" class="custom-tabs" @tab-click="handleTabClick">
            <el-tab-pane :name="'split'">
              <span slot="label">
                {{ $t('versionManage.subsection.intelligentSplit') }}
                <span class="tab-number">{{split_paragraphs.length}}</span>
              </span>
            </el-tab-pane>
            <el-tab-pane id="tab-multimodal" :name="'multimodal'" v-if="multi_modal_images && multi_modal_images.length > 0">
              <span slot="label">
                多模态解析
                <span class="tab-number">{{multi_modal_images.length}}</span>
              </span>
            </el-tab-pane>
          </el-tabs>
          <div class="headerRight">
            <template v-if="activeTab === 'split'">
              <div class="sort">
                <div class="sortTitle">
                  {{ $t('versionManage.subsection.sortTitle') }}
                  <el-tooltip class="item" effect="dark" :content="$t('versionManage.subsection.sortTip')" placement="top">
                    <i class="iconfont guoran-bangzhuzhongxin"></i>
                  </el-tooltip>
                </div>
                <el-switch
                    v-model="sortLock"
                    active-color="#366aff"
                    @change="changeSortLock"
                >
                </el-switch>
              </div>
              <div class="openBtn" @click="openOrClose('open')">
                <i class="iconfont guoran-kuozhan"></i>
                {{ $t('versionManage.subsection.expandAll') }}
              </div>
              <div class="closeBtn" @click="openOrClose('close')">
                <i class="iconfont guoran-tongyichicun-shouqi"></i>
                {{ $t('versionManage.subsection.collapseAll') }}
              </div>
            </template>
            <div class="saveBtn" @click="saveParse">
              <i class="iconfont guoran-a-16-03"></i>
              {{ $t('versionManage.subsection.save') }}
            </div>
          </div>
        </div>
        <!-- 智能分段内容 -->
        <div class="splitParagraphs" id="splitParagraphs" v-show="activeTab === 'split'">
          <div class="paragraphItem"
               v-for="(item,index) in split_paragraphs"
               :key="index"
               :id="'paragraph' + index"
               @drop="handleDrop($event, index)"
               @dragenter="setBorderColor(index)"
               @dragleave="clearBorderColor(index)"
          >
            <div class="paragraphTitle">
              <div class="titleLeft">
                <div class="title">{{ $t('versionManage.subsection.section', { index: index + 1 }) }}</div>
                <span v-if="item.type === 'table'">{{ $t('versionManage.subsection.table') }}</span>
                <div class="prompt" v-else-if="item.original_paragraph && item.original_paragraph.length > 0 && item.original_paragraph[0].type !== 'image'">{{ item.original_paragraph[0].text }}</div>
                <div class="prompt" v-else>{{ $t('versionManage.subsection.image') }}</div>
              </div>
              <div class="titleRight">
                <i class="iconfont guoran-tongyichicun-16-15-lianjibianji"
                   @click="editParagraphs(item,index)"
                   v-if="(editTableList[item.table_id] || editParagraphList[index]) && (!editStatusList[index] || !editStatusList[index].edit)"
                ></i>
                <i class="iconfont "
                   :class="statusList[index] && statusList[index].open ? 'guoran-tongyichicun-shouqi' : 'guoran-kuozhan'"
                   @click="setOpenClick(item,index)"
                ></i>
              </div>

            </div>
            <div class="paragraphContainer" v-show="statusList[index] && statusList[index].open">
              <template v-if="item.type !== 'table'">
                <template v-if="!editStatusList[index] || !editStatusList[index].edit">
                  <div class="paragraph" v-if="editParagraphList[index]">
                    <div class="text">{{ editParagraphList[index].paragraph }}</div>
                  </div>
                  <!--<div class="paragraph"
                       v-for="(items,indexs) in filterImages(item.images)"
                       :key="indexs">
                    <div class="image">
                      <el-image :src="items.oss_image_url" v-if="!items.ocr_image_text"></el-image>
                      <span v-else> {{items.ocr_image_text}} </span>
                    </div>
                  </div>-->
                </template>
                <template v-else>
                  <div class="editParagraph">
                    <div class="editHeader">
                      <div class="headerRight">
                        <i class="iconfont guoran-a-16-12" @click="paragraphFun(item,index,'reset')"></i>
                        <i class="iconfont guoran-tongyichicun-kaiqi1" @click="paragraphFun(item,index,'success')"></i>
                        <i class="iconfont guoran-shanchu" @click="paragraphFun(item,index,'cancel')"></i>
                      </div>
                    </div>
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 6, maxRows: 10 }"
                        placeholder="请输入内容"
                        v-model="editParagraphList[index].paragraph"
                        @change="changeParagraphList(index)"
                    >
                    </el-input>
                  </div>
                </template>
                <div class="originalParagraphs" :id="index + 'originalParagraphs'">
                  <div class="originalTitle">
                    {{ $t('versionManage.subsection.originalContent') }}
                    <div class="originalTip">
                      {{ $t('versionManage.subsection.originalTip') }}
                    </div>
                  </div>
                  <div class="originalParagraphList" :id="'originalParagraphList' + index">
                    <div class="originalParagraphItem"
                         v-for="(items,originalIndex) in getVisibleOriginalParagraphs(item)"
                         :key="originalIndex"
                         :id="(items.paragraph_id || items.id) + originalIndex"
                         :draggable="item.original_paragraph.length > 1 && (!editStatusList[index] || !editStatusList[index].edit) ? true:false"
                         @dragstart="handleDragStart($event, index, originalIndex,items)"
                         @click.stop="goToLeft(items)"

                    >
                      <div class="originalLeft">
                        <i class="iconfont guoran-tuodong my-handle" v-if="(!editStatusList[index] || !editStatusList[index].edit) && ((index > 0 ||
                           (item.original_paragraph.length > 1 && originalIndex !== 0) ||
                           (index < split_paragraphs.length - 1 && split_paragraphs[index + 1].type !== 'table')))"></i>
                        <div class="originalText" v-if="!items.type">{{ items.text }}</div>
                        <div class="image" v-else>
                          <template v-if="!items.ocr_image_text">
                            <el-image
                              :key="getImageKey(items.oss_image_url)"
                              :src="getSignedImageUrl(items.oss_image_url)"
                              @click="onImageClick(items.oss_image_url)"
                              style="height: 60px"
                            ></el-image>
                          </template>
                          <div v-else class="ocr_text" @click="onImageClick(items.oss_image_url)">
                            <div class="ocr_image_thumbnail">
                              <el-image
                                :key="getImageKey(items.oss_image_url) + '-ocr'"
                                :src="getSignedImageUrl(items.oss_image_url)"
                                style="height: 60px"
                              ></el-image>
                            </div>
                            <div class="ocr_content">
                              <span class="ocr_icon" :style="{ color:iconColors[items.oss_image_url] }">[来源于图片]</span>
                              <div class="ocr_image_text" v-html="items.text"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="originalRight" :style="{display:visible[index + 'visible' + originalIndex] ? 'flex' : ''}">
                        <template v-if="items.type === 'image'">
                          <div class="ocrIcon" v-if="(!editStatusList[index] || !editStatusList[index].edit) && !items.is_deleted">
                            <i class="iconfont guoran-OCR" @click.stop="ocrFun(items,index,'image')" v-if="!items.ocr_image_text"></i>
                            <i class="iconfont guoran-tongyichicun-tupian2" @click.stop="ocrFun(items,index)" v-else :style="{ color:iconColors[items.oss_image_url] }"></i>
                          </div>
                          <div v-if="items.is_deleted" class="delete_icon">
                            {{ $t('versionManage.subsection.isDeleted') }}
                          </div>
                        </template>
                        <el-popover
                            placement="bottom"
                            trigger="hover"
                            v-model="visible[index + 'visible' + originalIndex]"
                            popper-class="commitLoadMore"
                            content=""
                        >
                          <div class="popoverContainer" v-if="items.type !== 'image'">
                            <div class="popoverItem" @click="operate('pre',items,index,originalIndex)" v-if="index > 0">
                              <span>{{ $t('versionManage.subsection.moveToPreSection') }}</span>
                            </div>
                            <div class="popoverItem" @click="operate('next',items,index,originalIndex)" v-if="index < split_paragraphs.length - 1 && split_paragraphs[index + 1].type !== 'table'">
                              <span>{{ $t('versionManage.subsection.moveToNextSection') }}</span>
                            </div>
                            <div class="popoverItem" v-if="item.original_paragraph.length > 1 && originalIndex !== 0" @click="operate('new',items,index,originalIndex)">
                              <span>{{ $t('versionManage.subsection.newSection') }}</span>
                            </div>
                          </div>
                          <div class="popoverContainer" v-else>
                            <template v-if="!items.is_deleted">
                              <div class="popoverItem" @click="operate('pre',items,index,originalIndex,'image')" v-if="index > 0">
                                <span>{{ $t('versionManage.subsection.moveToPreSection') }}</span>
                              </div>
                              <div class="popoverItem" @click="operate('next',items,index,originalIndex,'image')" v-if="index < split_paragraphs.length - 1 && split_paragraphs[index + 1].type !== 'table'">
                                <span>{{ $t('versionManage.subsection.moveToNextSection') }}</span>
                              </div>
                              <div class="popoverItem" v-if="item.original_paragraph.length > 1 && originalIndex !== 0" @click="operate('new',items,index,originalIndex,'image')">
                                <span>{{ $t('versionManage.subsection.newSection') }}</span>
                              </div>
                              <div class="popoverItem" v-if="!items.is_deleted" @click="deleteImage(items,index,originalIndex)">
                                <span>{{ $t('versionManage.subsection.delete') }}</span>
                              </div>
                            </template>
                            <div class="popoverItem" v-else-if="items.is_deleted" @click="restoreImage(items,index,originalIndex)">
                              <span>{{ $t('versionManage.subsection.restore') }}</span>
                            </div>
                          </div>
                          <i slot="reference" class="iconfont guoran-qita1"
                             v-show="(!editStatusList[index] || !editStatusList[index].edit) && ((index > 0 ||
                           (item.original_paragraph.length > 1 && originalIndex !== 0) ||
                           (index < split_paragraphs.length - 1 && split_paragraphs[index + 1].type !== 'table')))"></i>
                        </el-popover>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="item.type === 'table'">
                <template v-if="!editStatusList[index] || !editStatusList[index].edit">
                  <div class="table">
                    <el-table
                        :data="tableData[item.table_id]"
                        border
                        ref="table"
                        style="width: 100%"
                        :empty-text="'暂无表格内容，您可以根据需要自行填写'"
                    >
                      <template v-for="(item,index) in headerArray[item.table_id]">
                        <el-table-column
                            :label="item.name"
                            :key="index"
                            min-width="100">
                          <template slot-scope="scope">
                            {{scope.row[item.id]}}
                          </template>
                        </el-table-column>
                      </template>
                    </el-table>
                  </div>
                </template>
                <template v-else>
                  <div class="editParagraph">
                    <div class="editHeader">
                      <div class="headerRight">
                        <i class="iconfont guoran-a-16-12" @click="paragraphFun(item,index,'reset',true)"></i>
                        <el-popover
                            placement="bottom"
                            width="200"
                            trigger="manual"
                            v-model="tableVisible[item.table_id]">
                          <div class="popoverContainer">
                            <div class="tips">当前编辑未保存,是否保存?</div>
                            <div class="popoverBtn">
                              <div class="same cancel" @click="paragraphFun(item,index,'cancel',true)">不保存并退出</div>
                              <div class="same confirm" @click="paragraphFun(item,index,'success',true)">保存</div>
                            </div>
                          </div>
                          <i class="iconfont guoran-tongyichicun-kaiqi1" @click="paragraphFun(item,index,'success',true)" slot="reference"></i>
                        </el-popover>
                        <i class="iconfont guoran-shanchu" @click="paragraphFun(item,index,'cancel',true)"></i>
                      </div>
                    </div>
                    <div v-if="editTableList[item.table_id] && editTableList[item.table_id].edit_previous_paragraph_text" class="editContainer">
                      <div class="tableHeader">
                        表格前内容
                        <div class="tableHeaderTip">
                          该部分内容为原文中表格的上文，可供大模型更好识别表格
                        </div>
                      </div>
                      <el-input
                          type="textarea"
                          :autosize="{ minRows: 3, maxRows: 6 }"
                          placeholder="请输入内容"
                          v-model="editTableList[item.table_id].edit_previous_paragraph_text"
                          @change="changeTableParagraph(item)"
                      >
                      </el-input>
                    </div>
                    <div class="editContainer tableContainer" :id="'table' + item.table_id">
                      <div class="tableHeader">
                        表格内容
                      </div>
                      <el-input
                          type="textarea"
                          :autosize="{ minRows: 6, maxRows: 10 }"
                          placeholder="请输入内容"
                          v-model="editTableList[item.table_id].edit_table_markdown_text"
                          @input="changeTableDown(item,index)"
                      >
                      </el-input>
                      <div class="tablePopover" :id="'popover' + item.table_id">
                        <el-table
                            :data="tableData[item.table_id]"
                            border
                            ref="table"
                            height="100%"
                            style="width: 100%"
                            :empty-text="'暂无表格内容，您可以根据需要自行填写'"
                        >
                          <template v-for="(item,index) in headerArray[item.table_id]">
                            <el-table-column
                                :label="item.name"
                                :key="index"
                                min-width="100">
                              <template slot-scope="scope">
                                {{scope.row[item.id]}}
                              </template>
                            </el-table-column>
                          </template>
                        </el-table>
                      </div>
                    </div>
                    <div v-if="editTableList[item.table_id] && editTableList[item.table_id].edit_next_paragraph_text" class="editContainer">
                      <div class="tableHeader">
                        表格后内容
                        <div class="tableHeaderTip">
                          该部分内容为原文中表格的下文，可供大模型更好识别表格
                        </div>
                      </div>
                      <el-input
                          type="textarea"
                          :autosize="{ minRows: 3, maxRows: 6 }"
                          placeholder="请输入内容"
                          v-model="editTableList[item.table_id].edit_next_paragraph_text"
                          @change="changeTableParagraph(item)"
                      >
                      </el-input>
                    </div>
                  </div>
                </template>
                <div class="originalParagraphs">
                  <div class="originalTitle">
                    {{ $t('versionManage.subsection.originalContent') }}
                    <div class="originalTip">
                      {{ $t('versionManage.subsection.originalTip') }}
                    </div>
                  </div>
                  <div class="originalParagraphList" :id="'originalParagraphList' + index">
                    <div class="originalParagraphItem"
                         v-for="(items,originalIndex) in item.original_paragraph"
                         :key="originalIndex"
                    >
                      <div class="originalLeft">
                        <div class="table" v-html="items.html"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- 多模态解析部分 -->
        <div class="multiModalSection" v-show="activeTab === 'multimodal'" v-if="multi_modal_images && multi_modal_images.length > 0">
          <div class="multiModalHeader" style="display: flex; justify-content: flex-end; padding: 10px 20px;">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="showAddMultiModalDialog">新增多模态图片</el-button>
          </div>
          <div class="multiModalList">
            <div class="multiModalItem" v-for="(item, index) in multi_modal_images" :key="item._tempId || index">
              <div class="multiModalContent">
                <div class="multiModalImage">
                  <el-image
                    :key="getImageKey(item.oss_image_url)"
                    :src="getSignedImageUrl(item.oss_image_url)"
                    :preview-src-list="[getSignedImageUrl(item.oss_image_url)]"
                    fit="cover"
                    style="width: 120px; height: 120px; border-radius: 4px;"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div class="imagePage">第{{ item.page }}页</div>
                </div>
                <div class="multiModalText">
                  <template v-if="!editMultiModalList[item._tempId]?.editing">
                    <div class="textContent" @click="goToMultiModalPage(item)">
                      {{ editMultiModalList[item._tempId]?.description ?? item.description }}
                      <div class="textActions" @click.stop>
                        <i class="iconfont guoran-tongyichicun-16-15-lianjibianji" @click.stop="startEditMultiModal(item)" title="编辑"></i>
                        <i class="iconfont guoran-shanchu" @click.stop="deleteMultiModal(item)" title="删除"></i>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="editContainer">
                      <el-input
                        type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                        v-model="editMultiModalList[item._tempId].description"
                        @input="markMultiModalDirty"
                        placeholder="请输入图片描述"
                      ></el-input>
                      <div class="editActions">
                        <el-button size="small" @click="cancelEditMultiModal(item)">取消</el-button>
                        <el-button type="primary" size="small" @click="saveEditMultiModal(item)">保存</el-button>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="loading" v-else>
        <img src="../../../assets/images/loading.gif">
        {{ $t('versionManage.subsection.splitting') }}
      </div>
    </div>
    <popup-com @closeEvent="ocrPopup = false" v-if="ocrPopup" :hideBool="hideBool">
      <div slot="popup-name" v-if="!hideBool">{{ $t('versionManage.subsection.warn') }}</div>
      <div slot="popup-con" class="orcTips">
        <div class="tip1">
          <img src="../../../assets/images/loading.gif" v-if="hideBool">
          {{ identifyMessage1 }}
        </div>
        <div class="tip1">{{ identifyMessage2 }}</div>
      </div>
      <div slot="dialog-footer" v-if="!hideBool">
        <el-button  plain size="small" @click="ocrPopup = false" class="cancel-btn">{{ $t('knowledgeManagement.folderManagement.cancel') }}</el-button>
        <el-button  type="primary" size="small" @click="confirmOcr"  class="confirm-btn">{{ $t('knowledgeManagement.folderManagement.confirm') }}</el-button>
      </div>
      </popup-com>
    <popup-com @closeEvent="cancelMultiModalWarning" v-if="multiModalWarningVisible">
      <div slot="popup-name">提示</div>
      <div slot="popup-tip">当前多模态解析内容有未保存的改动，离开后将丢失，是否继续？</div>
      <div slot="dialog-footer">
        <el-button plain size="small" @click="cancelMultiModalWarning" class="cancel-btn">取消</el-button>
        <el-button type="primary" size="small" @click="saveMultiModalAndLeave" class="confirm-btn">立即保存</el-button>
        <el-button type="text" size="small" @click="confirmMultiModalLeave" class="border-btn">离开</el-button>
      </div>
    </popup-com>
    <div v-if="showPreview">
      <custom-img-view
          :src="getSignedImageUrl(ocrImage)"
          :loading="loading"
          :ocrText="ocrText"
          :showOcrBtn="showOcrBtn"
          @closeViewer="closeViewer"
          @identifyOcr="identifyOcr"
      ></custom-img-view>
    </div>

    <!-- 新增多模态图片弹窗 -->
    <!-- 新增多模态图片弹窗 -->
    <popup-com @closeEvent="addMultiModalDialogVisible = false" v-if="addMultiModalDialogVisible">
      <div slot="popup-name">新增多模态图片</div>
      <div slot="popup-con" class="add-multimodal-container">
        <el-form :model="addMultiModalForm" label-width="80px" ref="addMultiModalForm">
          <el-form-item label="上传图片" required>
            <div 
              class="upload-area" 
              @click="triggerUpload" 
              @dragover.prevent 
              @drop.prevent="handleFileDrop"
              @paste="handlePaste"
              tabindex="0"
              ref="uploadArea"
            >
              <input type="file" ref="fileInput" @change="handleFileChange" style="display: none" accept="image/*">
              <div v-if="addMultiModalForm.previewUrl" class="preview-container">
                <img :src="addMultiModalForm.previewUrl" class="preview-img">
                <div class="preview-actions">
                  <i class="el-icon-delete" @click.stop="clearUpload"></i>
                </div>
              </div>
              <div v-else class="upload-placeholder">
                <i class="el-icon-upload"></i>
                <div class="upload-text">点击上传 / 拖拽图片到此处 / 粘贴图片 (Ctrl+V)</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="所属页码" required>
            <el-input-number v-model="addMultiModalForm.page" :min="1" label="页码"></el-input-number>
          </el-form-item>
          <el-form-item label="图片描述" required>
            <el-input type="textarea" v-model="addMultiModalForm.description" :rows="4" placeholder="请输入图片描述"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="dialog-footer">
        <el-button plain size="small" @click="addMultiModalDialogVisible = false" class="cancel-btn">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmAddMultiModal" :loading="uploading" class="confirm-btn">确 定</el-button>
      </div>
    </popup-com>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import pdfView from "@/views/versionManage/components/pdfView";
import { v4 as uuidv4 } from "uuid";

import { requestUrl } from "@/http/requestUrl";
import PopupCom from "@/components/popup";
import DocView from "@/views/versionManage/components/docView";
import CustomImgView from "@/components/customImgView";
import { upload, ossFileUrl } from "@/assets/js/AliyunIssUtil";
export default {
  name: "subsectionCom",
  data(){
    return{
      html:"",
      "split_paragraphs":[],
      tables:[],
      draggedItem: null,  // 当前拖动的文本块
      draggedItemIndex: null,  // 当前拖动的文本块索引
      colors: ['#E3EBFF', '#FFF5DC', '#FFE8D8','#D6F3EA','#FFF1C3'],
      iconColorList:["#366aff","#bf0000","#ffaaff"],
      iconColors:{},
      goRightId:null,
      visible:{},
      parseInfo:{},
      split_paragraphs_copy:"[]",
      fileSuffix:"docx",
      statusList:{},
      editStatusList:{},
      html_result:"",
      loadingSplit:true,
      identifyMessage1:"",
      identifyMessage2:"",
      ocrPopup:false,
      hideBool:false,
      identifyType:"",
      originalType:"",
      showPreview:false,
      ocrImage:"",
      ocrText:"OCR识别图片内容",
      loading:false,
      ocrIndex:0,
      ocrId:"",
      ocrType:"",
      unrelated_images:[],
      multi_modal_images:[], // 多模态解析图片数组
      editMultiModalList:{}, // 编辑中的多模态文本
      multiModalDirty: false,
      pendingTabName: null,
      tabChangeLock: false,
      multiModalWarningVisible: false,
      activeTab: 'split', // 当前激活的tab：'split' 或 'multimodal'
      editParagraphList:{},
      sortLock:true,
      sortable:{},
      showOcrBtn:true,
      checkStatus:{}, //编辑之后分段操作提示
      drop_split_paragraphs_copy:"",//拖动前记录下当前的分段情况
      edit_paragraph:{},
      ocr_image_text:"",
      editTableList:{},
      tablePopover:{},
      tableData:{},//记录表格行数据
      headerArray:{},//记录表格表头
      editTableId:"",//当前正在编辑的表格id
      tableVisible:{},
      editIndex:"", //编辑表格时记录下标，当前正在编辑用与滚动到指定编辑位置
      editTableListCopy:null,//编辑前保存点击x的时候用与恢复编辑前内容
      paragraph_reset:{},
      edit_table:{},
      imageSignatureCache: {}, // 图片签名缓存
      
      // 新增多模态图片相关
      addMultiModalDialogVisible: false,
      addMultiModalForm: {
        page: 1,
        description: '',
        file: null,
        previewUrl: ''
      },
      uploading: false
    }
  },
  props:{
    ossPath:{
      type:String,
      default:""
    }
  },
  computed: {
    // 判断是否是音频文件
    isAudioFile() {
      const audioFormats = ['mp3', 'wav', 'm4a', 'aac', 'flac', 'ogg', 'amr'];
      return audioFormats.includes(this.fileSuffix?.toLowerCase());
    },
    // 解码音频 URL（从 base64 解码）
    decodedAudioSrc() {
      if (!this.ossPath || !this.isAudioFile) return '';
      try {
        // 尝试 base64 解码
        const decoded = atob(this.ossPath);
        return decoded;
      } catch (e) {
        // 如果不是 base64 编码，直接返回原 URL
        return this.ossPath;
      }
    }
  },
  components:{
    CustomImgView,
    DocView,
    PopupCom,
    pdfView
  },
  watch: {
    activeTab(newVal, oldVal) {
      if (this.tabChangeLock) {
        return;
      }
      if (oldVal === 'multimodal' && newVal !== 'multimodal' && this.multiModalDirty) {
        this.pendingTabName = newVal;
        this.tabChangeLock = true;
        this.activeTab = oldVal;
        this.multiModalWarningVisible = true;
      }
    }
  },
  methods:{
    getParagraphIdFromEvent(e) {
      let node = e && e.target ? e.target : null;
      while (node && node !== this.$el) {
        if (node.dataset && node.dataset.paragraphId) {
          return node.dataset.paragraphId;
        }
        if (node.getAttribute) {
          const attrId = node.getAttribute('paragraph-id');
          if (attrId) {
            return attrId;
          }
        }
        if (node.id) {
          return node.id;
        }
        node = node.parentNode;
      }
      return '';
    },
    handleTabClick(tab) {
      // tab切换处理
      this.activeTab = tab.name;
    },
    setMultiModalImages(images) {
      this.multi_modal_images = Array.isArray(images) ? images.slice() : [];
      this.multi_modal_images.forEach(item => {
        this.ensureMultiModalTempId(item);
      });
      this.sortMultiModalImages();
      this.syncMultiModalEditList();
    },
    ensureMultiModalTempId(item) {
      if (!item) {
        return null;
      }
      if (!item._tempId) {
        this.$set(item, '_tempId', uuidv4());
      }
      return item._tempId;
    },
    sortMultiModalImages() {
      if (!Array.isArray(this.multi_modal_images) || this.multi_modal_images.length === 0) {
        return;
      }
      this.multi_modal_images.sort((a, b) => {
        const aPage = Number(a.page) || 0;
        const bPage = Number(b.page) || 0;
        return aPage - bPage;
      });
    },
    syncMultiModalEditList() {
      const newList = {};
      if (!Array.isArray(this.multi_modal_images)) {
        this.editMultiModalList = newList;
        return;
      }
      this.multi_modal_images.forEach(item => {
        const tempId = this.ensureMultiModalTempId(item);
        newList[tempId] = {
          description: item.description || '',
          editing: false
        };
      });
      this.editMultiModalList = newList;
    },
    setLeftHtmlDiv(){
      for (let i=0;i<this.split_paragraphs.length;i++){
        const dom = document.createElement('div');
        dom.setAttribute('class', 'leftParagraphItem');
        for (let j=0;j<this.split_paragraphs[i].original_paragraph.length;j++){
          let id = this.split_paragraphs[i].original_paragraph[j].paragraph_id;
          let domItem = document.getElementById(id);
          if (domItem){
            dom.appendChild(domItem);
          }
          // this.$refs.subsectionLeft.replaceChild(dom, this.$refs.subsectionLeft);
        }
        this.$refs.subsectionLeft.appendChild(dom)
      }

    },
    async getParseInfo(){
      let url = requestUrl.correction.parseInfo + this.$route.query.knowledgeId;
      await this.$http.get(url).then(async res => {
        if (res.data.code == 0 && res.data.data){
          this.parseInfo = res.data.data;
          
          // 添加调试信息
          console.log('解析信息:', res.data.data);
          console.log('文件类型:', res.data.data.fileType);
          console.log('文件后缀:', this.fileSuffix);
          
          // 处理Markdown文件的特殊逻辑
          if (this.fileSuffix === 'md' || this.fileSuffix === 'markdown') {
            console.log('检测到Markdown文件，使用特殊处理逻辑');
            if (res.data.data.extractChunkInfo && res.data.data.extractChunkInfo.docChunkData) {
              const docChunkData = res.data.data.extractChunkInfo.docChunkData;
              
              // 确保Markdown文件的html_result正确设置
              if (docChunkData.html_result) {
                this.html_result = docChunkData.html_result;
                console.log('Markdown文件HTML结果已设置:', this.html_result);
              } else {
                console.warn('Markdown文件没有找到html_result');
              }
              
              // 处理Markdown的分段信息
              if (docChunkData.paragraphs) {
                if (docChunkData.paragraphs.split_paragraphs) {
                  this.split_paragraphs = docChunkData.paragraphs.split_paragraphs;
                  console.log('Markdown分段信息已设置:', this.split_paragraphs.length, '个段落');
                } else if (docChunkData.paragraphs) {
                  this.split_paragraphs = docChunkData.paragraphs;
                  console.log('Markdown分段信息已设置:', this.split_paragraphs.length, '个段落');
                }
              }
              
              // 处理Markdown的表格信息
              if (docChunkData.tables && docChunkData.tables.length > 0) {
                this.tables = docChunkData.tables;
                console.log('Markdown表格信息已设置:', this.tables.length, '个表格');
              }
              
              // 处理Markdown的无关图片
              if (docChunkData.unrelated_images) {
                this.unrelated_images = docChunkData.unrelated_images;
                console.log('Markdown无关图片已设置:', this.unrelated_images.length, '张图片');
              }
              
              // 处理Markdown的多模态解析图片
              if (docChunkData.multi_modal_images) {
                this.setMultiModalImages(docChunkData.multi_modal_images);
                console.log('Markdown多模态解析图片已设置:', this.multi_modal_images.length, '张图片');
              }
            }
          }
          // 处理图片文件的分段信息
          else if (res.data.data.extractChunkInfo && res.data.data.extractChunkInfo.imageChunkData && 
                   res.data.data.extractChunkInfo.imageChunkData.status === 'success' && 
                   res.data.data.extractChunkInfo.imageChunkData.parsed_content) {
            console.log('检测到图片文件，使用imageChunkData处理');
            const imageChunkData = res.data.data.extractChunkInfo.imageChunkData;
            if (imageChunkData.parsed_content && imageChunkData.parsed_content.docChunkData) {
              const docChunkData = imageChunkData.parsed_content.docChunkData;
              
              // 处理图片的分段信息
              if (docChunkData.split_paragraphs && docChunkData.split_paragraphs.length > 0) {
                this.split_paragraphs = docChunkData.split_paragraphs;
                console.log('图片分段信息已设置:', this.split_paragraphs.length, '个段落');
              }
              
              // 处理图片的表格信息
              if (docChunkData.tables && docChunkData.tables.length > 0) {
                this.tables = docChunkData.tables;
                console.log('图片表格信息已设置:', this.tables.length, '个表格');
              }
              
              // 处理图片的HTML结果
              if (docChunkData.html_result) {
                this.html_result = docChunkData.html_result;
                console.log('图片HTML结果已设置');
              }
              
              // 处理图片信息
              if (docChunkData.images && docChunkData.images.length > 0) {
                this.unrelated_images = docChunkData.images.map(img => ({
                  ...img,
                  type: 'image',
                  source: 'imageChunkData'
                }));
                console.log('图片信息已设置:', this.unrelated_images.length, '张图片');
              }
            } else {
              console.warn('图片文件解析失败或状态不正确:', imageChunkData);
            }
          }
          // 处理普通文档的分段信息（Word、PDF、TXT等）
          else if (res.data.data.extractChunkInfo && res.data.data.extractChunkInfo.docChunkData){
            console.log('检测到普通文档，使用docChunkData处理');
            console.log('文件类型:', res.data.data.fileType);
            console.log('docChunkData结构:', res.data.data.extractChunkInfo.docChunkData);
            
            const docChunkData = res.data.data.extractChunkInfo.docChunkData;
            
            // 处理分段信息 - 优先使用 split_paragraphs
            if (docChunkData.paragraphs && docChunkData.paragraphs.split_paragraphs) {
              this.split_paragraphs = docChunkData.paragraphs.split_paragraphs;
              console.log('普通文档分段信息已设置 (split_paragraphs):', this.split_paragraphs.length, '个段落');
              console.log('分段信息内容:', this.split_paragraphs);
            } else if (docChunkData.paragraphs) {
              this.split_paragraphs = docChunkData.paragraphs;
              console.log('普通文档分段信息已设置 (paragraphs):', this.split_paragraphs.length, '个段落');
            } else {
              console.warn('普通文档未找到分段信息');
              console.log('docChunkData.paragraphs:', docChunkData.paragraphs);
            }
            
            // 处理HTML结果
            if (docChunkData.html_result) {
              this.html_result = docChunkData.html_result;
              console.log('普通文档HTML结果已设置');
            }
            
            // 处理表格信息
            if (docChunkData.tables && docChunkData.tables.length > 0) {
              this.tables = docChunkData.tables;
              console.log('普通文档表格信息已设置:', this.tables.length, '个表格');
            }
            
            // 处理无关图片
            if (docChunkData.unrelated_images) {
              this.unrelated_images = docChunkData.unrelated_images;
              console.log('普通文档无关图片已设置:', this.unrelated_images.length, '张图片');
            }
            
            // 处理多模态解析图片
            if (docChunkData.multi_modal_images) {
              this.setMultiModalImages(docChunkData.multi_modal_images);
              console.log('多模态解析图片已设置:', this.multi_modal_images.length, '张图片');
            }
          } else {
            console.warn('未找到有效的分段信息');
            console.log('extractChunkInfo:', res.data.data.extractChunkInfo);
          }
        }
        let arr = []


        for (let i =0 ;i <this.tables.length;i++){
          if (this.tables[i].table_html){
            let obj = {
              type:'table',
              html:this.tables[i].table_html,
              paragraph:"",
              original_paragraph:[
                {
                  html:this.tables[i].table_html,
                  position:this.tables[i].bbox,
                  page:this.tables[i].page
                }
              ],
              paragraph_id:uuidv4(),
              position:this.tables[i].bbox,
              table_id:this.tables[i].table_id,
              page:this.tables[i].page
            }
            let edit_table_markdown = this.tables[i].edit_table_markdown ? this.tables[i].edit_table_markdown : this.tables[i].table_markdown;
            let edit_table_text = edit_table_markdown.table_header;
            if (edit_table_markdown.table_header){
              const index = edit_table_markdown.table_header.indexOf('| --- |');
              if (index !== -1) {
                edit_table_text = edit_table_markdown.table_header.substring(0, index)
              }
            }
            for (let t =0 ;t<edit_table_markdown.table_data.length;t++){
              let row_data_md = JSON.parse(JSON.stringify(edit_table_markdown.table_data[t].row_data_md)).replaceAll('\n',"")
              edit_table_text += '\n' + row_data_md
            }
            let editTableObj = {
              edit_next_paragraph_text:this.tables[i].edit_next_paragraph_text ? this.tables[i].edit_next_paragraph_text : this.tables[i].next_paragraph_text,
              edit_previous_paragraph_text:this.tables[i].edit_previous_paragraph_text ? this.tables[i].edit_previous_paragraph_text : this.tables[i].previous_paragraph_text,
              edit_table_markdown_text:edit_table_text,
              table_markdown:this.tables[i].table_markdown,
              edit_table_markdown:this.tables[i].edit_table_markdown ? this.tables[i].edit_table_markdown : this.tables[i].table_markdown,
              next_paragraph_text:this.tables[i].next_paragraph_text,
              previous_paragraph_text:this.tables[i].previous_paragraph_text
            }
            this.$set(this.editTableList,this.tables[i].table_id,editTableObj);
            this.setDownTable(this.tables[i])
            arr.push(obj)
          }
          if (this.tables[i].tables_html){
            for (let i=0;i<this.tables[i].tables_html.length;i++){
              let obj = {
                type:'table',
                html:this.tables[i].tables_html[i],
                paragraph:"",
                original_paragraph:[
                  {
                    html:this.tables[i].tables_html[i],
                    position:this.tables[i].bbox,
                    page:this.tables[i].page
                  }
                ],
                paragraph_id:uuidv4(),
                position:this.tables[i].bbox,
                page:this.tables[i].page
              }
              arr.push(obj)
            }
          }
        }


        this.split_paragraphs = this.split_paragraphs.concat(arr);

        if (this.unrelated_images.length > 0){
          this.unrelated_images = this.unrelated_images.map((img,index) => {
            img.type = 'image';
            img.source = "unrelated_images";
            const ocrText = this.extractImageText(img);
            if (ocrText){
              img.text = ocrText;
            }
            const colorIndex = index % this.iconColorList.length;
            this.iconColors[img.oss_image_url] = this.iconColorList[colorIndex];
            return img
          })
          let obj = {
            original_paragraph:this.unrelated_images,
            images:[],
            paragraph:""
          }
          this.split_paragraphs.push(obj)
        }
        console.log('过滤前的分段数量:', this.split_paragraphs.length);
        console.log('过滤前的分段内容:', this.split_paragraphs);
        
        this.split_paragraphs = this.split_paragraphs.filter(item => (item.original_paragraph.length > 0))
        
        console.log('过滤后的分段数量:', this.split_paragraphs.length);
        console.log('过滤后的分段内容:', this.split_paragraphs);
        
        await this.processAssociatedImage();
        
        console.log('processAssociatedImage后的分段数量:', this.split_paragraphs.length);
        console.log('processAssociatedImage后的分段内容:', this.split_paragraphs);
        
        // 特殊处理图片文件的分段信息
        if (this.parseInfo.fileType === 'PNG' || this.parseInfo.fileType === 'JPG' || this.parseInfo.fileType === 'JPEG') {
          console.log('处理图片文件的分段信息');
          // 确保图片文件的分段信息有正确的结构
          this.split_paragraphs = this.split_paragraphs.map(item => {
            if (item.original_paragraph && item.original_paragraph.length > 0) {
              // 确保每个段落都有正确的文本内容
              item.original_paragraph = item.original_paragraph.map(para => {
                if (para.text) {
                  return para;
                } else if (para.paragraph) {
                  return {
                    ...para,
                    text: para.paragraph
                  };
                }
                return para;
              });
            }
            return item;
          });
        }
        
        console.log('最终过滤前的分段数量:', this.split_paragraphs.length);
        console.log('最终过滤前的分段内容:', this.split_paragraphs);
        
        this.split_paragraphs = this.split_paragraphs.map(item => {
          item.original_paragraph = item.original_paragraph.filter(items => items.text || items.type === 'image' || items.html)
          return item
        })
        
        console.log('最终过滤后的分段数量:', this.split_paragraphs.length);
        console.log('最终过滤后的分段内容:', this.split_paragraphs);
        
        // 针对Markdown文件的调试信息
        if (this.fileSuffix === 'md' || this.fileSuffix === 'markdown') {
          console.log('Markdown文件最终处理结果:');
          console.log('html_result:', this.html_result);
          console.log('split_paragraphs数量:', this.split_paragraphs.length);
          console.log('split_paragraphs详情:', this.split_paragraphs);
          console.log('tables数量:', this.tables.length);
          console.log('unrelated_images数量:', this.unrelated_images.length);
        }
        
        // 针对PDF文件的调试信息
        if (this.fileSuffix === 'pdf') {
          console.log('PDF文件最终处理结果:');
          console.log('html_result:', this.html_result);
          console.log('split_paragraphs数量:', this.split_paragraphs.length);
          console.log('split_paragraphs详情:', this.split_paragraphs);
          console.log('tables数量:', this.tables.length);
          console.log('unrelated_images数量:', this.unrelated_images.length);
        }
        
        this.split_paragraphs_copy = JSON.stringify(this.split_paragraphs);
        for (let i=0;i<this.split_paragraphs.length;i++){
          if (this.split_paragraphs[i].edit_paragraph){
            this.$set(this.editParagraphList,i,{paragraph:this.split_paragraphs[i].edit_paragraph})
          } else if (this.split_paragraphs[i].paragraph){
            this.$set(this.editParagraphList,i,{paragraph:this.split_paragraphs[i].paragraph})
          }
        }
        this.loadingSplit = false;
        this.drop_split_paragraphs_copy = JSON.stringify(this.split_paragraphs);
        this.multiModalDirty = false;
      })
    },
    processAssociatedImage(){
      /* 把关联图片拿出来，为了单行显示一个图片。保存时需要将关联图片再push到关联到文字中 */
      for (let i=0;i<this.split_paragraphs.length;i++){
        if (this.split_paragraphs[i].original_paragraph){
          for (let j=0;j<this.split_paragraphs[i].original_paragraph.length;j++){
            let item = this.split_paragraphs[i].original_paragraph[j];
            if (item.images && item.images.length > 0) {
              let aggregatedImageTexts = [];
              for (let k = 0;k<item.images.length;k++){
                let original_paragraph = [];
                let imagesItem = item.images[k];
                /* 新更改的ocr_image_text要取ocr返回之后的全部值 */
                if (imagesItem.ocr_image_text && imagesItem.ocr_image_text.split_paragraphs){
                  for (let m = 0;m < imagesItem.ocr_image_text.split_paragraphs.length; m++){
                    let new_original_paragraph = []
                    for (let o = 0;o<imagesItem.ocr_image_text.split_paragraphs[m].original_paragraph.length;o++){
                      const ocrParagraph = imagesItem.ocr_image_text.split_paragraphs[m].original_paragraph[o];
                      let obj = {
                        oss_image_url:imagesItem.oss_image_url,
                        id:imagesItem.id,
                        is_deleted:imagesItem.is_deleted,
                        type:"image",
                        ocr_image_text:imagesItem.ocr_image_text ? JSON.parse(JSON.stringify(imagesItem.ocr_image_text)) : null,
                        paragraph_id:ocrParagraph.paragraph_id || imagesItem.id || `${imagesItem.id || 'image'}_${m}_${o}`,
                        text:ocrParagraph.text,
                        // 优先使用OCR段落的位置信息，缺失时退回到图片本身的定位
                        position:Array.isArray(ocrParagraph.position) ? ocrParagraph.position : imagesItem.position,
                        page:typeof ocrParagraph.page === 'number' ? ocrParagraph.page : imagesItem.page
                      }
                      new_original_paragraph.push(obj)
                    }
                    original_paragraph = original_paragraph.concat(new_original_paragraph)
                    aggregatedImageTexts = aggregatedImageTexts.concat(new_original_paragraph.map(paragraph => paragraph.text || ''))
                  }
                  this.split_paragraphs[i].original_paragraph.splice(j + 1,0,...original_paragraph)
                } else if (imagesItem.ocr_image_text && imagesItem.ocr_image_text.tables){
                  let tables = []
                  for (let m = 0;m < imagesItem.ocr_image_text.tables.length; m++){
                    let obj = {
                      oss_image_url:imagesItem.oss_image_url,
                      id:imagesItem.id,
                      is_deleted:imagesItem.is_deleted,
                      type:"image",
                      ocr_image_text:imagesItem.ocr_image_text ? JSON.parse(JSON.stringify(imagesItem.ocr_image_text)) : null,
                      paragraph_id:(imagesItem.ocr_image_text.tables[m] && imagesItem.ocr_image_text.tables[m].paragraph_id) || imagesItem.id || `${imagesItem.id || 'image'}_table_${m}`,
                      text:imagesItem.ocr_image_text.tables[m].table_html,
                      position:Array.isArray(imagesItem.ocr_image_text.tables[m].position) ? imagesItem.ocr_image_text.tables[m].position : imagesItem.position,
                      page:typeof imagesItem.ocr_image_text.tables[m].page === 'number' ? imagesItem.ocr_image_text.tables[m].page : imagesItem.page
                    }
                    tables.push(obj)
                  }
                  original_paragraph = original_paragraph.concat(tables)
                  aggregatedImageTexts = aggregatedImageTexts.concat(tables.map(table => table.text || ''))
                  this.split_paragraphs[i].original_paragraph.splice(j + 1,0,...original_paragraph)
                } else {
                  imagesItem.type = 'image';
                  imagesItem.text = imagesItem.ocr_image_text;
                  aggregatedImageTexts.push(imagesItem.text || '')
                  this.split_paragraphs[i].original_paragraph.splice(j + 1,0,imagesItem)
                }
                const colorIndex = j % this.iconColorList.length;
                this.iconColors[imagesItem.oss_image_url] = this.iconColorList[colorIndex]
              }
              if (aggregatedImageTexts.length > 0){
                const originalText = this.normalizeText(item.text || '');
                const imageText = this.normalizeText(aggregatedImageTexts.join(''));
                if (this.shouldHideParagraph(originalText, imageText)){
                  this.$set(this.split_paragraphs[i].original_paragraph[j],'__hide_after_process',true)
                }
              }
              item.images = [];
            }
          }
        }
      }
    },
    extractImageText(image){
      if (!image || !image.ocr_image_text){
        return '';
      }
      const texts = [];
      const { split_paragraphs, tables } = image.ocr_image_text;
      if (Array.isArray(split_paragraphs)){
        split_paragraphs.forEach(paragraph => {
          if (Array.isArray(paragraph.original_paragraph)){
            paragraph.original_paragraph.forEach(item => {
              if (item && item.text){
                texts.push(item.text);
              }
            })
          } else if (paragraph && paragraph.paragraph){
            texts.push(paragraph.paragraph);
          }
        })
      }
      if (Array.isArray(tables)){
        tables.forEach(table => {
          if (table && table.table_html){
            texts.push(table.table_html);
          }
        })
      }
      return texts.join('\n').trim();
    },
    normalizeText(text){
      if (text === null || text === undefined){
        return '';
      }
      return String(text).replace(/\s+/g,'').trim();
    },
    shouldHideParagraph(originalText,imageText){
      if (!originalText || !imageText){
        return false;
      }
      if (originalText === imageText){
        return true;
      }
      if (originalText.includes(imageText) || imageText.includes(originalText)){
        return true;
      }
      const similarity = this.getTextSimilarity(originalText, imageText);
      if (similarity >= 0.8){
        return true;
      }
      const lengthDiff = Math.abs(originalText.length - imageText.length);
      if (similarity >= 0.7 && lengthDiff <= 2){
        return true;
      }
      return false;
    },
    getTextSimilarity(source,target){
      if (!source || !target){
        return 0;
      }
      const rows = source.length + 1;
      const cols = target.length + 1;
      const dp = new Array(rows);
      for (let i = 0; i < rows; i++){
        dp[i] = new Array(cols).fill(0);
      }
      for (let i = 1; i < rows; i++){
        for (let j = 1; j < cols; j++){
          if (source[i - 1] === target[j - 1]){
            dp[i][j] = dp[i - 1][j - 1] + 1;
          } else {
            dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
          }
        }
      }
      const longestCommon = dp[rows - 1][cols - 1];
      const maxLen = Math.max(source.length, target.length) || 1;
      return longestCommon / maxLen;
    },
    getVisibleOriginalParagraphs(paragraph){
      if (!paragraph || !Array.isArray(paragraph.original_paragraph)){
        return [];
      }
      return paragraph.original_paragraph.filter(item => !item.__hide_after_process);
    },
    async saveParse(type){
      let url = requestUrl.correction.saveParseInfo;
      let split_paragraphs = this.split_paragraphs.filter(item => item.type !== 'table');
      let unrelated_images = [];
      for (let k in this.editParagraphList){
        if (this.edit_paragraph[k]){
          split_paragraphs[k].edit_paragraph = this.editParagraphList[k].paragraph
        } else if (this.paragraph_reset[k]){
          split_paragraphs[k].edit_paragraph = null;
        }
      }
      for (let i=0;i<split_paragraphs.length;i++){
        for (let j=0;j<split_paragraphs[i].original_paragraph.length;j++){
          let item = split_paragraphs[i].original_paragraph[j];
          if (item.type === 'image'){
            if (j == 0){
              if (item.source === 'unrelated_images'){
                unrelated_images.push(item)
              } else {
                split_paragraphs[i].original_paragraph[j] = {
                  images:[item],
                  title:"",
                  text:"",
                  paragraph_id:uuidv4(),
                  paragraph:""
                }
              }
            } else {
              let ids = [];
              if (split_paragraphs[i].original_paragraph[j-1].text && split_paragraphs[i].original_paragraph[j-1].images){
                ids = split_paragraphs[i].original_paragraph[j-1].images.map(img => img.id)
                if (ids.indexOf(item.id) == -1){
                  split_paragraphs[i].original_paragraph[j-1].images.push(item);
                }
              } else if (item.source === 'unrelated_images'){
                unrelated_images.push(item)
              } else {
                split_paragraphs[i].original_paragraph[j] = {
                  images:[item],
                  title:"",
                  text:"",
                  paragraph_id:uuidv4(),
                  paragraph:""
                }
              }
              split_paragraphs[i].original_paragraph.splice(j,1);
              j = j-1;
            }
          }
        }
      }
      split_paragraphs = split_paragraphs.map(item => {
        item.original_paragraph = item.original_paragraph.filter(items => items.type !== 'image')
        return item
      })
      for (let i=0;i<this.tables.length;i++){
        if (this.edit_table[this.tables[i].table_id]){
          if (this.editTableList[this.tables[i].table_id].edit_next_paragraph_text){
            this.tables[i].edit_next_paragraph_text = this.editTableList[this.tables[i].table_id].edit_next_paragraph_text;
          }
          if (this.editTableList[this.tables[i].table_id].edit_previous_paragraph_text){
            this.tables[i].edit_previous_paragraph_text = this.editTableList[this.tables[i].table_id].edit_previous_paragraph_text;
          }
          if (this.editTableList[this.tables[i].table_id].edit_table_markdown){
            this.tables[i].edit_table_markdown = this.editTableList[this.tables[i].table_id].edit_table_markdown;
          }
        }
      }
      // 检查 paragraphs 是否存在，如果不存在则初始化
      if (!this.parseInfo.extractChunkInfo.docChunkData.paragraphs) {
        this.parseInfo.extractChunkInfo.docChunkData.paragraphs = {};
      }
      
      // 设置分段信息
      this.parseInfo.extractChunkInfo.docChunkData.paragraphs.split_paragraphs = split_paragraphs.filter(item => item.original_paragraph.length > 0);
      this.parseInfo.extractChunkInfo.docChunkData.unrelated_images = unrelated_images;
      this.parseInfo.extractChunkInfo.docChunkData.tables = this.tables
      // 保存多模态解析图片的修改（包括删除和编辑）
      // 确保docChunkData存在
      if (!this.parseInfo.extractChunkInfo.docChunkData) {
        this.parseInfo.extractChunkInfo.docChunkData = {};
      }
      // 更新所有编辑过的描述
      if (this.multi_modal_images && this.multi_modal_images.length > 0) {
        this.multi_modal_images.forEach((item) => {
          const editInfo = this.editMultiModalList[item._tempId];
          if (editInfo && editInfo.description !== undefined) {
            item.description = editInfo.description;
          }
        });
      }
      // 无论数组是否为空，都要保存（如果被全部删除，则保存空数组）
      this.parseInfo.extractChunkInfo.docChunkData.multi_modal_images = this.multi_modal_images || [];
      return this.$http.post(url,this.parseInfo).then(async res => {
        if (res.data.code == 0){
            this.$message({
              message:this.$t('versionManage.subsection.saveSuccess'),
              type:"success"
            })
            this.multiModalDirty = false;
            this.checkStatus = {};
            this.editStatusList = {};
            this.edit_paragraph = {};
            this.edit_table = {};
            this.editTableId = ""
            // this.split_paragraphs_copy = JSON.stringify(this.split_paragraphs)
            await this.getParseInfo();
        }
        if (type === 'back' && res.data.code == 0){
          this.$parent.goBack();
        }
      })
    },
    cancelMultiModalWarning() {
      this.multiModalWarningVisible = false;
      this.pendingTabName = null;
      this.tabChangeLock = false;
    },
    confirmMultiModalLeave() {
      if (!this.pendingTabName) {
        this.cancelMultiModalWarning();
        return;
      }
      const target = this.pendingTabName;
      this.tabChangeLock = true;
      this.multiModalWarningVisible = false;
      this.pendingTabName = null;
      this.activeTab = target;
      this.$nextTick(() => {
        this.tabChangeLock = false;
      });
    },
    saveMultiModalAndLeave() {
      if (!this.pendingTabName) {
        return;
      }
      const target = this.pendingTabName;
      this.tabChangeLock = true;
      this.saveParse().then(() => {
        this.multiModalWarningVisible = false;
        this.pendingTabName = null;
        this.activeTab = target;
      }).finally(() => {
        this.tabChangeLock = false;
      });
    },
    goBack(){
      // 记录的 从其他系统跳转过来的信息
      if (sessionStorage.getItem('toVersionManage')) {
        this.$router.push({ path: '/knowledge_Management' })
        sessionStorage.removeItem('toVersionManage')
      } else {
        this.$router.push({ path: '/knowledge_Management', query: { isback: 1 } })
      }
    },
    // 新增多模态图片相关方法
    showAddMultiModalDialog() {
      this.addMultiModalForm = {
        page: 1,
        description: '',
        file: null,
        previewUrl: ''
      };
      this.addMultiModalDialogVisible = true;
      this.$nextTick(() => {
        if(this.$refs.uploadArea) {
          this.$refs.uploadArea.focus();
        }
      });
    },
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      this.handleFile(file);
    },
    handleFileDrop(e) {
      const file = e.dataTransfer.files[0];
      this.handleFile(file);
    },
    handlePaste(e) {
      const items = e.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          this.handleFile(file);
          break;
        }
      }
    },
    handleFile(file) {
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件');
        return;
      }
      // 限制大小 10MB
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('图片大小不能超过 10MB');
        return;
      }
      
      this.addMultiModalForm.file = file;
      this.addMultiModalForm.previewUrl = URL.createObjectURL(file);
    },
    clearUpload() {
      this.addMultiModalForm.file = null;
      this.addMultiModalForm.previewUrl = '';
      if(this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    async confirmAddMultiModal() {
      if (!this.addMultiModalForm.file) {
        this.$message.warning('请上传图片');
        return;
      }
      if (!this.addMultiModalForm.description) {
        this.$message.warning('请输入图片描述');
        return;
      }
      
      this.uploading = true;
      try {
        const file = this.addMultiModalForm.file;
        const config = {}; // Config isn't strictly needed for the simplified upload util usage but passing empty obj
        const res = await upload(config, file);
        
        if (res && res.name) {
          const ossUrl = await ossFileUrl(config, res.name, null);
          
          const newImage = {
            page: this.addMultiModalForm.page,
            oss_image_url: ossUrl, // 这里可能需要去除 https: 前缀或者根据后端要求处理，暂时保持完整URL
            description: this.addMultiModalForm.description,
            type: "image"
          };
          
          if (!this.multi_modal_images) {
            this.multi_modal_images = [];
          }
          this.ensureMultiModalTempId(newImage);
          this.multi_modal_images.push(newImage);
          this.sortMultiModalImages();
          this.$set(this.editMultiModalList, newImage._tempId, {
            description: newImage.description,
            editing: false
          });
          this.markMultiModalDirty();
          
          this.addMultiModalDialogVisible = false;
          
          // 自动滚动到新增的多模态项
          this.$nextTick(() => {
            setTimeout(() => {
              // 通过 _tempId 找到新增图片在排序后数组中的位置
              const targetTempId = newImage._tempId;
              const targetIndex = this.multi_modal_images.findIndex(item => item._tempId === targetTempId);
              
              const multiModalItems = document.querySelectorAll('.multiModalItem');
              if (targetIndex >= 0 && targetIndex < multiModalItems.length) {
                const targetItem = multiModalItems[targetIndex];
                if (targetItem) {
                  targetItem.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'center',
                    inline: 'nearest'
                  });
                }
              }
            }, 300);
          });
        } else {
           this.$message.error('上传失败');
        }
      } catch (error) {
        console.error('Upload error:', error);
        this.$message.error('上传出错: ' + error.message);
      } finally {
        this.uploading = false;
      }
    },
    sortableList(index){
      let _this = this;
      let id = 'originalParagraphList' + index
      let el = document.getElementById(id);
      this.sortable[index] = new Sortable(el, {
        animation: 200,
        easing: "cubic-bezier(1, 0, 0, 1)",
        handle: ".my-handle",
        sort:this.sortLock ? false : true,
        onUpdate: function (event) {
          if (_this.checkStatus[index] == undefined &&
              _this.editParagraphList[index] &&
              _this.editParagraphList[index].paragraph !== _this.split_paragraphs[index].paragraph){
            _this.$confirm(_this.$t('versionManage.subsection.sourceParagraph'), _this.$t('versionManage.subsection.confirmTitle'), {
              confirmButtonText: _this.$t('common.confirm'),
              cancelButtonText: _this.$t('common.cancel'),
              type: 'warning'
            }).then(() => {
              _this.checkStatus[index] = true;
              _this.editParagraphList[index].paragraph = _this.split_paragraphs[index].paragraph;
              _this.edit_paragraph[index] = false;
              //修改items数据顺序
              let newIndex = event.newIndex,
                  oldIndex = event.oldIndex,
                  $li = el.children[newIndex],
                  $oldLi = el.children[oldIndex];
              // 先删除移动的节点
              el.removeChild($li)
              // 再插入移动的节点到原有节点，还原了移动的操作
              if (newIndex > oldIndex) {
                el.insertBefore($li, $oldLi)
              } else {
                el.insertBefore($li, $oldLi.nextSibling)
              }
              // 更新items数组
              let item = _this.split_paragraphs[index].original_paragraph.splice(oldIndex, 1)
              _this.split_paragraphs[index].original_paragraph.splice(newIndex, 0, item[0]);
              _this.drop_split_paragraphs_copy = JSON.stringify(_this.split_paragraphs);
            }).catch(() => {
              _this.checkStatus[index] = undefined;
              _this.split_paragraphs = JSON.parse(_this.drop_split_paragraphs_copy);
            })
          } else {
            //修改items数据顺序
            let newIndex = event.newIndex,
                oldIndex = event.oldIndex,
                $li = el.children[newIndex],
                $oldLi = el.children[oldIndex];
            // 先删除移动的节点
            el.removeChild($li)
            // 再插入移动的节点到原有节点，还原了移动的操作
            if (newIndex > oldIndex) {
              el.insertBefore($li, $oldLi)
            } else {
              el.insertBefore($li, $oldLi.nextSibling)
            }
            // 更新items数组
            let item = _this.split_paragraphs[index].original_paragraph.splice(oldIndex, 1)
            _this.split_paragraphs[index].original_paragraph.splice(newIndex, 0, item[0]);
            _this.drop_split_paragraphs_copy = JSON.stringify(_this.split_paragraphs);
          }
        },
      });
    },
    setColor(){
      this.split_paragraphs.forEach((item,index) => {
        const colorIndex = index % this.colors.length;
        if (item.original_paragraph){
          item.original_paragraph.forEach(items => {
            let dom = document.getElementById(items.paragraph_id);
            if (dom){
              dom.style.background = this.colors[colorIndex];
            }
          })
          let newOriginal = item.original_paragraph.filter(items => !items.type)
          let dom = document.getElementById(newOriginal[newOriginal.length - 1].paragraph_id);
          if (dom){
            dom.style.marginBottom = '8px';
          }
        }
      })
    },
    editParagraphs(item,index){
      if (this.editTableId){
        let id = 'paragraph' + this.editIndex;
        let dom = document.getElementById(id);
        if (dom){
          dom.scrollIntoView({ behavior: 'smooth' });
        }
        this.$set(this.tableVisible,this.editTableId,true)
        return
      }
      if (this.editStatusList[index] && this.editStatusList[index].edit){
        this.$set(this.editStatusList[index],'edit',false)
      } else {
        this.$set(this.editStatusList,index,{ edit:true })
        this.$set(this.statusList,index,{ open:true })
      }
      if (item.table_id){
        let id = 'table' + item.table_id;
        this.editTableId = item.table_id;
        this.editIndex = index;
        this.editTableListCopy = JSON.stringify(this.editTableList[item.table_id])
        this.$nextTick(() => {
          let height = document.getElementById(id).clientHeight;
          let popoverId = 'popover' + item.table_id;
          document.getElementById(popoverId).style.top = height + 100 + 'px'
        })
      }
    },
    setOpenClick(item,index){
      if (this.statusList[index] && this.statusList[index].open){
        this.$set(this.statusList[index],'open',false)
      } else {
        this.$set(this.statusList,index,{ open:true })
        this.$nextTick(() => {
          if (this.sortable[index]){
            if (this.sortLock){
              this.sortable[index].option('sort',false)
            } else {
              this.sortable[index].option('sort',true)
            }
          } else {
            this.sortableList(index);
          }
        })
      }
    },
    paragraphFun(item,index,type,isTable){
      if (isTable){
        this.tablePopover[item.table_id] = false;
        this.editTableId = "";
        this.tableVisible[item.table_id] = false;
        if (type === 'success'){
          this.$set(this.editStatusList[index],'edit',false)
          // item.edit_next_paragraph_text = this.editTableList[item.table_id].edit_next_paragraph_text;
          // item.edit_previous_paragraph_text = this.editTableList[item.table_id].edit_previous_paragraph_text;
          this.setDownTable(item,'success')
        } else if (type == 'reset'){
          this.$set(this.editStatusList[index],'edit',false)
          this.$set(this.edit_paragraph,index,false)
          this.edit_table[item.table_id] = false;
          if (item.edit_next_paragraph_text){
            delete item.edit_next_paragraph_text
          }
          if (item.edit_previous_paragraph_text){
            delete item.edit_previous_paragraph_text
          }
          if (item.edit_table_markdown){
            delete item.edit_table_markdown
          }
          let edit_table_markdown = this.editTableList[item.table_id].table_markdown;
          let edit_table_text = edit_table_markdown.table_header;
          if (edit_table_markdown.table_header){
            const index = edit_table_markdown.table_header.indexOf('| --- |');
            if (index !== -1) {
              edit_table_text = edit_table_markdown.table_header.substring(0, index)
            }
          }
          for (let t =0 ;t<edit_table_markdown.table_data.length;t++){
            let row_data_md = JSON.parse(JSON.stringify(edit_table_markdown.table_data[t].row_data_md)).replaceAll('\n',"")
            edit_table_text += '\n' + row_data_md
          }
          this.editTableList[item.table_id].edit_next_paragraph_text = this.editTableList[item.table_id].next_paragraph_text;
          this.editTableList[item.table_id].edit_previous_paragraph_text = this.editTableList[item.table_id].previous_paragraph_text;
          this.editTableList[item.table_id].edit_table_markdown_text = edit_table_text;
          this.setDownTable(item)
        } else {
          this.$set(this.editStatusList[index],'edit',false);
          if (this.editTableListCopy){
            this.editTableList[item.table_id] = JSON.parse(this.editTableListCopy);
          }
          this.setDownTable(item)
        }
        return
      }
      this.checkStatus[index] = undefined;
      this.$set(this.paragraph_reset,index,false)
      if (type === 'success'){
        this.$set(this.editStatusList[index],'edit',false)
      } else if (type === 'reset'){
        this.$set(this.editStatusList[index],'edit',false)
        this.editParagraphList[index].paragraph = this.split_paragraphs[index].paragraph;
        this.$set(this.edit_paragraph,index,false)
        this.$set(this.paragraph_reset,index,true)
      } else {
        this.editParagraphList[index].paragraph = this.split_paragraphs[index].paragraph;
        this.$set(this.editStatusList[index],'edit',false)
      }
    },
    tableRowData(item,headerData,excelRowList){
      this.$set(this.tableData,item.table_id,[])
      this.$set(this.headerArray,item.table_id,[])
      const headerString = headerData.trim().replace(/^\||\|$/g, '');
      // 使用竖线作为分隔符来分割字符串
      const headerArray = headerString.split('|').map(item => item.trim());

      for (let i =0;i<headerArray.length;i++){
        let obj = {
          name:headerArray[i],
          id:uuidv4()
        }
        this.headerArray[item.table_id].push(obj)
      }
      for (let i =0;i<excelRowList.length;i++){
        // 去除字符串两端的竖线（如果它们存在的话）
        const trimmedString = excelRowList[i].row_data_md.trim().replace(/^\||\|$/g, '');

        // 使用竖线作为分隔符来分割字符串
        let resultArray = trimmedString.split('|').map(item => item.trim());
        // resultArray = resultArray.filter(res => res)
        let obj = {};
        for (let j=0;j<this.headerArray[item.table_id].length;j++){
          if (resultArray[j]){
            this.$set(obj,this.headerArray[item.table_id][j].id,resultArray[j])
          }
        }
        this.tableData[item.table_id].push(obj);
      }
    },
    setDownTable(item,type){
      let arr = this.editTableList[item.table_id].edit_table_markdown_text.split('\n');
      arr = arr.filter(data => data);
      let table_data = []
      for (let i=1;i<arr.length;i++){
        let obj = {
          row_data_md:arr[i],
          row_id:uuidv4(),
          row_number:null,
          table_html:null
        }
        table_data.push(obj)
      }
      let tableDown = {
        table_header:arr[0],
        table_data
      }
      if (type !== 'success'){
        this.tableRowData(item,tableDown.table_header,tableDown.table_data)
        if (type == 'change'){
          this.editTableList[item.table_id].edit_table_markdown = tableDown;
        }
      } else {
        // item.edit_table_markdown = tableDown;
        this.editTableList[item.table_id].edit_table_markdown = tableDown;
      }
    },
    // 拖动开始
    handleDragStart(event, splitIndex, originalIndex,items) {
      this.drop_split_paragraphs_copy = JSON.stringify(this.split_paragraphs);
      this.draggedItemIndex = { splitIndex, originalIndex };
      this.originalType = items.type
      event.dataTransfer.setData("text/plain", `${splitIndex}-${originalIndex}`);
    },

    // 拖动过程中
    handleDragOver(event) {
      event.preventDefault();  // 必须阻止默认事件才能允许 drop 事件
    },
    setBorderColor(index){
      if (index !== this.draggedItemIndex.splitIndex){
        let domId = 'paragraph' + index;
        let dom = document.getElementById(domId);
        if (dom){
          dom.style.borderColor = '#366aff'
        }
      }
    },
    clearBorderColor(index){
      let domId = 'paragraph' + index;
      let dom = document.getElementById(domId);
      if (dom){
        dom.style.borderColor = '#ffffff'
      }
    },
    // 拖动放下
    handleDrop(event, targetSplitIndex, targetOriginalIndex) {
      const source = this.draggedItemIndex;  // 被拖动的项的来源
      const target = { splitIndex: targetSplitIndex, originalIndex: targetOriginalIndex };
      if (this.split_paragraphs[target.splitIndex].type === 'table'){
        return
      }
      if (this.sortLock && source.splitIndex !== target.splitIndex && (target.splitIndex + 1 == source.splitIndex || target.splitIndex - 1 == source.splitIndex)) {
        this.dropParagraphs(targetSplitIndex,targetOriginalIndex)
      } else if (!this.sortLock && source.splitIndex !== target.splitIndex){
        this.dropParagraphs(targetSplitIndex,targetOriginalIndex)
      }
    },
    dropParagraphs(targetSplitIndex, targetOriginalIndex){
      const source = this.draggedItemIndex;  // 被拖动的项的来源
      const target = { splitIndex: targetSplitIndex, originalIndex: targetOriginalIndex };
      const newOriginalIndex = source.originalIndex + 1;
      let attr = 'original_paragraph';
      let item = [];
      if (target.splitIndex + 1 == source.splitIndex){
        item = this.split_paragraphs[source.splitIndex][attr].splice(0, newOriginalIndex);
        this.$set(this.split_paragraphs[target.splitIndex], attr, this.split_paragraphs[target.splitIndex][attr].concat(item));
      } else if (target.splitIndex - 1 == source.splitIndex){
        item = this.split_paragraphs[source.splitIndex][attr].splice(source.originalIndex, this.split_paragraphs[source.splitIndex][attr].length);
        this.$set(this.split_paragraphs[target.splitIndex], attr, item.concat(this.split_paragraphs[target.splitIndex][attr]));
      }
      let id = '';
      let clearBottomDomId = ''
      if (item.length > 0 && this.split_paragraphs.length > 0){
        if (target.splitIndex + 1 == source.splitIndex){
          id = item[item.length - 1].paragraph_id + (this.split_paragraphs[target.splitIndex].original_paragraph.length - item.length);
          if (this.split_paragraphs[target.splitIndex].original_paragraph.length - 1 - item.length >= 0){
            clearBottomDomId = this.split_paragraphs[target.splitIndex].original_paragraph[this.split_paragraphs[target.splitIndex].original_paragraph.length - 1 - item.length].paragraph_id
          }
        } else {
          id = target.splitIndex + 'originalParagraphs';
          clearBottomDomId = item[item.length - 1].paragraph_id
        }
      }
      let sourceParagraphBool = this.checkStatus[source.splitIndex] == undefined &&
          this.editParagraphList[source.splitIndex] &&
          this.editParagraphList[source.splitIndex].paragraph !== this.split_paragraphs[source.splitIndex].paragraph;
      let targetParagraphBool = this.checkStatus[target.splitIndex] == undefined &&
          this.editParagraphList[target.splitIndex] &&
          this.editParagraphList[target.splitIndex].paragraph !== this.split_paragraphs[target.splitIndex].paragraph;
      let messageTitle = this.$t('versionManage.subsection.sourceParagraph')
      if (sourceParagraphBool && targetParagraphBool){
        messageTitle = this.$t('versionManage.subsection.sourceAndTarget')
      } else if (targetParagraphBool){
        messageTitle = this.$t('versionManage.subsection.targetParagraph')
      }
      if (sourceParagraphBool || targetParagraphBool){
        this.$confirm(messageTitle, this.$t('versionManage.subsection.confirmTitle'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          if (sourceParagraphBool && targetParagraphBool){
            this.checkStatus[source.splitIndex] = true;
            this.checkStatus[target.splitIndex] = true
          } else if (sourceParagraphBool){
            this.checkStatus[source.splitIndex] = true;
          } else if (targetParagraphBool){
            this.checkStatus[target.splitIndex] = true
          }
          if (!this.statusList[target.splitIndex]){
            this.$set(this.statusList,target.splitIndex,{ open:false })
          }
          this.$set(this.statusList[target.splitIndex],'open',true)
          if (this.sortable[target.splitIndex]){
            if (this.sortLock){
              this.sortable[target.splitIndex].option('sort',false)
            } else {
              this.sortable[target.splitIndex].option('sort',true)
            }
          } else {
            this.sortableList(target.splitIndex);
          }
          // 删除源段落的 item.text
          const sourceParagraph = this.split_paragraphs[source.splitIndex];
          if (item.length > 0){
            let paragraph = ""
            for (let i=0;i<item.length;i++){
              // 合并 item.text 到目标段落的 paragraph 字段中
              if (item[i].text){
                paragraph += item[i].text
                sourceParagraph.paragraph = sourceParagraph.paragraph.replace(item[i].text, '').trim();
              }
            }
            if (target.splitIndex - 1 == source.splitIndex){
              this.split_paragraphs[target.splitIndex].paragraph = paragraph + this.split_paragraphs[target.splitIndex].paragraph
            } else {
              this.split_paragraphs[target.splitIndex].paragraph += paragraph;
            }
            this.$set(this.editParagraphList,source.splitIndex,{paragraph:sourceParagraph.paragraph})
            this.$set(this.editParagraphList,target.splitIndex,{paragraph:this.split_paragraphs[target.splitIndex].paragraph})
          }
          this.edit_paragraph[source.splitIndex] = false;
          // 如果目标段落的 original_paragraph 为空，删除该段落
          if (this.split_paragraphs[source.splitIndex].original_paragraph.length === 0) {
            this.split_paragraphs.splice(source.splitIndex, 1);
          }
          //添加完元素滚动到指定位置
          setTimeout(() => {
            const el = document.getElementById(id);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
            }
            const dom = document.getElementById(clearBottomDomId);
            if (dom){
              dom.style.marginBottom = '0'
            }
            if (this.fileSuffix !== 'pdf'){
              this.$refs.docView.setColor();
            }
          },300)
          this.drop_split_paragraphs_copy = JSON.stringify(this.split_paragraphs);
        }).catch(() => {
          if (sourceParagraphBool && targetParagraphBool){
            this.checkStatus[source.splitIndex] = undefined;
            this.checkStatus[target.splitIndex] = undefined
          } else if (sourceParagraphBool){
            this.checkStatus[source.splitIndex] = undefined;
          } else if (targetParagraphBool){
            this.checkStatus[target.splitIndex] = undefined
          }
          this.split_paragraphs = JSON.parse(this.drop_split_paragraphs_copy);
        });
      } else {
        if (!this.statusList[target.splitIndex]){
          this.$set(this.statusList,target.splitIndex,{ open:false })
        }
        this.$set(this.statusList[target.splitIndex],'open',true)
        if (this.sortable[target.splitIndex]){
          if (this.sortLock){
            this.sortable[target.splitIndex].option('sort',false)
          } else {
            this.sortable[target.splitIndex].option('sort',true)
          }
        } else {
          this.sortableList(target.splitIndex);
        }
        // 删除源段落的 item.text
        const sourceParagraph = this.split_paragraphs[source.splitIndex];
        if (item.length > 0){
          let paragraph = ""
          for (let i=0;i<item.length;i++){
            // 合并 item.text 到目标段落的 paragraph 字段中
            if (item[i].text){
              paragraph += item[i].text
              sourceParagraph.paragraph = sourceParagraph.paragraph.replace(item[i].text, '').trim();
            }
          }
          if (target.splitIndex - 1 == source.splitIndex){
            this.split_paragraphs[target.splitIndex].paragraph = paragraph + this.split_paragraphs[target.splitIndex].paragraph
          } else {
            this.split_paragraphs[target.splitIndex].paragraph += paragraph;
          }
          this.$set(this.editParagraphList,source.splitIndex,{paragraph:sourceParagraph.paragraph})
          this.$set(this.editParagraphList,target.splitIndex,{paragraph:this.split_paragraphs[target.splitIndex].paragraph})
        }
        this.edit_paragraph[source.splitIndex] = false;
        // 如果目标段落的 original_paragraph 为空，删除该段落
        if (this.split_paragraphs[source.splitIndex].original_paragraph.length === 0) {
          this.split_paragraphs.splice(source.splitIndex, 1);
        }
        //添加完元素滚动到指定位置
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
          const dom = document.getElementById(clearBottomDomId);
          if (dom){
            dom.style.marginBottom = '0'
          }
          if (this.fileSuffix !== 'pdf'){
            this.$refs.docView.setColor();
          }
        },300)
        this.drop_split_paragraphs_copy = JSON.stringify(this.split_paragraphs);
      }
    },
    selectDiv(e){
      this.goRightId = null;
      const paragraphId = this.getParagraphIdFromEvent(e);
      if (!paragraphId) {
        return;
      }
      for (let i=0;i<this.split_paragraphs.length;i++){
        if (this.split_paragraphs[i].original_paragraph){
          for (let j=0;j<this.split_paragraphs[i].original_paragraph.length;j++){
            if (this.split_paragraphs[i].original_paragraph[j].paragraph_id == paragraphId){
              this.goRightId = {i,j};
              if (!this.statusList[i]){
                this.$set(this.statusList,i,{ open:false })
              }
              this.$set(this.statusList[i],'open',true);
              setTimeout(() => {
                let id = 'paragraph' + i
                const el = document.getElementById(id);
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth' });
                  this.$nextTick(() => {
                    el.style.animation = 'blink-border 3s infinite'
                  })
                }
                if (this.sortable[i]){
                  if (this.sortLock){
                    this.sortable[i].option('sort',false)
                  } else {
                    this.sortable[i].option('sort',true)
                  }
                } else {
                  this.sortableList(i);
                }
              },300)
              return;
            }
          }
        }
      }
    },
    async goToLeft(item){
      const hasPdfViewer = this.$refs.pdfView && typeof this.$refs.pdfView.scrollToHighlight === 'function';
      if (hasPdfViewer){
        await this.scrollPdfToParagraph(item);
        return;
      }
      let id = item.paragraph_id;
      const el =
        document.getElementById(id) ||
        document.querySelector(`[data-paragraph-id="${id}"]`) ||
        document.querySelector(`[paragraph-id="${id}"]`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        this.$nextTick(() => {
          el.classList.add('animation');
          setTimeout(() => {
            el.classList.remove('animation')
          },3000)
        })
      } else if (!item.paragraph_id){
        await this.scrollPdfToParagraph(item);
      }
    },
    async scrollPdfToParagraph(item){
      if (!this.$refs.pdfView || !item){
        return;
      }
      const pageNumber = this.getPdfPageNumber(item.page);
      if (!pageNumber){
        return;
      }
      await this.$refs.pdfView.loadPage(pageNumber);
      if (Array.isArray(item.position) && item.position.length >= 4){
        setTimeout(() => {
          this.$refs.pdfView.scrollToHighlight({ pageNumber,position:item.position })
        },300)
      }
    },
    getPdfPageNumber(page){
      const minPage = this.getMinPdfPageValue();
      const offset = minPage === 0 ? 1 : 0;
      let pageNumber = Number(page);
      if (isNaN(pageNumber)){
        pageNumber = 1 - offset;
      }
      pageNumber += offset;
      if (pageNumber < 1){
        pageNumber = 1;
      }
      const maxPage = this.$refs.pdfView && this.$refs.pdfView.numPages ? this.$refs.pdfView.numPages : null;
      if (maxPage && pageNumber > maxPage){
        pageNumber = maxPage;
      }
      return pageNumber;
    },
    getMinPdfPageValue(){
      let minPage = null;
      if (Array.isArray(this.split_paragraphs)){
        for (let i = 0; i < this.split_paragraphs.length; i++){
          const section = this.split_paragraphs[i];
          if (!section || !Array.isArray(section.original_paragraph)){
            continue;
          }
          for (let j = 0; j < section.original_paragraph.length; j++){
            const value = Number(section.original_paragraph[j].page);
            if (isNaN(value)){
              continue;
            }
            if (minPage === null || value < minPage){
              minPage = value;
            }
          }
        }
      }
      return minPage;
    },
    openOrClose(type){
      this.split_paragraphs.forEach((item,index) => {
        if (!this.statusList[index]){
          this.$set(this.statusList,index,{ open:false })
        }
        if (type === 'open'){
          this.$set(this.statusList[index],'open',true)
        } else {
          this.$set(this.statusList[index],'open',false)
        }
        this.$nextTick(() => {
          if (this.sortable[index]){
            if (this.sortLock){
              this.sortable[index].option('sort',false)
            } else {
              this.sortable[index].option('sort',true)
            }
          } else {
            this.sortableList(index);
          }
        })
      })
    },
    changeSortLock(){
      for (let i=0;i<this.split_paragraphs.length;i++){
        if (this.statusList[i] && this.statusList[i].open){
          if (this.sortable[i]){
            if (this.sortLock){
              this.sortable[i].option('sort',false)
            } else {
              this.sortable[i].option('sort',true)
            }
          } else {
            this.sortableList(i);
          }
        }
      }
    },
    operate(type,item,index,originalIndex){
      let list = [];
      let goToIndex = 0;
      let attr = 'original_paragraph';
      if (type === 'pre'){
        list = this.split_paragraphs[index][attr].splice(0, originalIndex + 1);
        goToIndex = index - 1;
        this.$set(this.split_paragraphs[index - 1], attr, this.split_paragraphs[index - 1][attr].concat(list));
      } else{
        list = this.split_paragraphs[index][attr].splice(originalIndex, this.split_paragraphs[index][attr].length);
        goToIndex = index + 1;
        if (type === 'next'){
          this.$set(this.split_paragraphs[index + 1], attr, list.concat(this.split_paragraphs[index + 1][attr]));
        } else {
          let obj = {
            paragraph :'',
            original_paragraph:list,
            images:[]
          }
          this.split_paragraphs.splice(index + 1, 0, obj);
        }
      }

      this.visible[index + 'visible' + originalIndex] = false;
      let sourceParagraphBool = this.checkStatus[index] == undefined &&
          this.editParagraphList[index] &&
          this.editParagraphList[index].paragraph !== this.split_paragraphs[index].paragraph;
      let targetParagraphBool = this.checkStatus[goToIndex] == undefined &&
          this.editParagraphList[goToIndex] &&
          this.editParagraphList[goToIndex].paragraph !== this.split_paragraphs[goToIndex].paragraph && type !== 'new';
      let messageTitle = this.$t('versionManage.subsection.sourceParagraph')
      if (sourceParagraphBool && targetParagraphBool){
        messageTitle = this.$t('versionManage.subsection.sourceAndTarget')
      } else if (targetParagraphBool){
        messageTitle = this.$t('versionManage.subsection.targetParagraph')
      }
      if (sourceParagraphBool || targetParagraphBool){
        this.$confirm(messageTitle, this.$t('versionManage.subsection.confirmTitle'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          if (sourceParagraphBool && targetParagraphBool){
            this.checkStatus[index] = true;
            this.checkStatus[goToIndex] = true
            this.edit_paragraph[index] = false;
            this.edit_paragraph[goToIndex] = false;
          } else if (sourceParagraphBool){
            this.checkStatus[index] = true;
            this.edit_paragraph[index] = false;
          } else if (targetParagraphBool){
            this.checkStatus[goToIndex] = true
            this.edit_paragraph[goToIndex] = false;
          }
          // 删除源段落的 item.text
          const sourceParagraph = this.split_paragraphs[index];
          let paragraph = ""
          if (list.length > 0){
            for (let i=0;i<list.length;i++){
              // 合并 item.text 到目标段落的 paragraph 字段中
              if (list[i].text){
                paragraph += list[i].text
                sourceParagraph.paragraph = sourceParagraph.paragraph.replace(list[i].text, '').trim();
              }
            }
            if (type !== 'pre'){
              this.split_paragraphs[goToIndex].paragraph = paragraph + this.split_paragraphs[goToIndex].paragraph
            } else {
              this.split_paragraphs[goToIndex].paragraph += paragraph;
            }
          }
          if (!this.statusList[goToIndex]){
            this.$set(this.statusList,goToIndex,{ open:false })
          }
          this.statusList[goToIndex].open = true;
          let id = ''
          if (type === 'pre'){
            id = this.split_paragraphs[goToIndex].original_paragraph[this.split_paragraphs[goToIndex].original_paragraph.length - list.length].paragraph_id + (this.split_paragraphs[goToIndex].original_paragraph.length - list.length);
          } else {
            id = goToIndex + 'originalParagraphs';
          }
          let clearBottomDomId = ''
          if (this.split_paragraphs[goToIndex][attr].length - 1 - list.length >= 0){
            if (type === 'pre'){
              clearBottomDomId = this.split_paragraphs[goToIndex].original_paragraph[this.split_paragraphs[goToIndex].original_paragraph.length - 1 - list.length].paragraph_id
            } else {
              clearBottomDomId = this.split_paragraphs[goToIndex].original_paragraph[list.length - 1].paragraph_id
            }
          }
          //添加完元素滚动到指定位置
          setTimeout(() => {
            const el = document.getElementById(id);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
            }
            const dom = document.getElementById(clearBottomDomId);
            if (dom){
              dom.style.marginBottom = '0'
            }
            if (this.fileSuffix !== 'pdf'){
              this.$refs.docView.setColor();
            }
            // 如果目标段落的 original_paragraph 为空，删除该段落
            if (this.split_paragraphs[index].original_paragraph.length === 0) {
              this.split_paragraphs.splice(index, 1);
            }
            for (let i=0;i<this.split_paragraphs.length;i++){
              if (!this.edit_paragraph[i]){
                this.$set(this.editParagraphList,i,{paragraph:this.split_paragraphs[i].paragraph})
              }
            }
            if (type === 'new'){
              this.sortableList(this.split_paragraphs.length - 1);
            } else if (this.sortable[goToIndex]){
              if (this.sortLock){
                this.sortable[goToIndex].option('sort',false)
              } else {
                this.sortable[goToIndex].option('sort',true)
              }
            } else {
              this.sortableList(goToIndex);
            }
          },300)
          this.drop_split_paragraphs_copy = JSON.stringify(this.split_paragraphs);
        }).catch(() => {
          if (sourceParagraphBool && targetParagraphBool){
            this.checkStatus[index] = undefined;
            this.checkStatus[goToIndex] = undefined
          } else if (sourceParagraphBool){
            this.checkStatus[index] = undefined;
          } else if (targetParagraphBool){
            this.checkStatus[goToIndex] = undefined
          }
          this.split_paragraphs = JSON.parse(this.drop_split_paragraphs_copy);
        });
      } else {
        if (!this.statusList[goToIndex]){
          this.$set(this.statusList,goToIndex,{ open:false })
        }
        this.statusList[goToIndex].open = true;
        // 删除源段落的 item.text
        const sourceParagraph = this.split_paragraphs[index];
        let paragraph = ""
        if (list.length > 0){
          for (let i=0;i<list.length;i++){
            // 合并 item.text 到目标段落的 paragraph 字段中
            if (list[i].text){
              paragraph += list[i].text
              sourceParagraph.paragraph = sourceParagraph.paragraph.replace(list[i].text, '').trim();
            }
          }
          if (type !== 'pre'){
            this.split_paragraphs[goToIndex].paragraph = paragraph + this.split_paragraphs[goToIndex].paragraph
          } else {
            this.split_paragraphs[goToIndex].paragraph += paragraph;
          }
        }
        this.edit_paragraph[index] = false;
        let id = ''
        if (type === 'pre'){
          id = this.split_paragraphs[goToIndex].original_paragraph[this.split_paragraphs[goToIndex].original_paragraph.length - list.length].paragraph_id + (this.split_paragraphs[goToIndex].original_paragraph.length - list.length);
        } else {
          id = goToIndex + 'originalParagraphs';
        }
        let clearBottomDomId = ''
        if (this.split_paragraphs[goToIndex][attr].length - 1 - list.length >= 0){
          if (type === 'pre'){
            clearBottomDomId = this.split_paragraphs[goToIndex].original_paragraph[this.split_paragraphs[goToIndex].original_paragraph.length - 1 - list.length].paragraph_id
          } else {
            clearBottomDomId = this.split_paragraphs[goToIndex].original_paragraph[list.length - 1].paragraph_id
          }
        }
        //添加完元素滚动到指定位置
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
          const dom = document.getElementById(clearBottomDomId);
          if (dom){
            dom.style.marginBottom = '0'
          }
          if (this.fileSuffix !== 'pdf'){
            this.$refs.docView.setColor();
          }
          // 如果目标段落的 original_paragraph 为空，删除该段落
          if (this.split_paragraphs[index].original_paragraph.length === 0) {
            this.split_paragraphs.splice(index, 1);
          }
          for (let i=0;i<this.split_paragraphs.length;i++){
            if (!this.edit_paragraph[i]){
              this.$set(this.editParagraphList,i,{paragraph:this.split_paragraphs[i].paragraph})
            }
          }
          if (type === 'new'){
            this.sortableList(this.split_paragraphs.length - 1);
          } else if (this.sortable[goToIndex]){
            if (this.sortLock){
              this.sortable[goToIndex].option('sort',false)
            } else {
              this.sortable[goToIndex].option('sort',true)
            }
          } else {
            this.sortableList(goToIndex);
          }
        },300)
        this.drop_split_paragraphs_copy = JSON.stringify(this.split_paragraphs);
      }
    },
    deleteImage(items,index){
      this.$confirm(this.$t('versionManage.subsection.confirmDelete'), this.$t('versionManage.subsection.delete'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.$set(items,'is_deleted',true)
        for (let i=0;i<this.split_paragraphs[index].original_paragraph.length;i++){
          if (this.split_paragraphs[index].original_paragraph[i].type === 'image' && this.split_paragraphs[index].original_paragraph[i].ocr_image_text){
            if ((this.split_paragraphs[index].original_paragraph[i].id && (this.split_paragraphs[index].original_paragraph[i].id === items.id)) || this.split_paragraphs[index].original_paragraph[i].oss_image_url === items.oss_image_url){
              this.split_paragraphs[index].paragraph = this.split_paragraphs[index].paragraph.replace(this.split_paragraphs[index].original_paragraph[i].text,"");
              this.editParagraphList[index].paragraph = this.editParagraphList[index].paragraph.replace(this.split_paragraphs[index].original_paragraph[i].text,"");
            }
            if (this.split_paragraphs[index].original_paragraph[i].oss_image_url === items.oss_image_url){
              this.split_paragraphs[index].original_paragraph[i].is_deleted = true;
            }
          }
        }
        this.$message({
          message: this.$t('versionManage.subsection.deleteSuccess'),
          type:"success"
        })
      }).catch(() => {

      })
    },
    // 多模态解析相关方法
    startEditMultiModal(item) {
      const tempId = this.ensureMultiModalTempId(item);
      if (!this.editMultiModalList[tempId]) {
        this.$set(this.editMultiModalList, tempId, {
          description: item.description || '',
          editing: false
        });
      }
      this.$set(this.editMultiModalList[tempId], 'editing', true);
    },
    cancelEditMultiModal(item) {
      const tempId = this.ensureMultiModalTempId(item);
      const editInfo = this.editMultiModalList[tempId];
      if (editInfo) {
        this.$set(editInfo, 'description', item.description || '');
        this.$set(editInfo, 'editing', false);
      }
    },
    saveEditMultiModal(item) {
      const tempId = this.ensureMultiModalTempId(item);
      const editInfo = this.editMultiModalList[tempId];
      if (editInfo) {
        item.description = editInfo.description;
        this.$set(editInfo, 'editing', false);
        this.markMultiModalDirty();
      }
    },
    markMultiModalDirty() {
      if (!this.multiModalDirty) {
        this.multiModalDirty = true;
      }
    },
    deleteMultiModal(item) {
      const tempId = this.ensureMultiModalTempId(item);
      this.$confirm('确定要删除这条多模态解析吗？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.multi_modal_images = this.multi_modal_images.filter(image => image._tempId !== tempId);
        this.$delete(this.editMultiModalList, tempId);
        this.markMultiModalDirty();
      }).catch(() => {
        // 取消删除
      });
    },
    // 跳转到多模态图片所在页面
    async goToMultiModalPage(item) {
      if (!item || !item.page) {
        return;
      }
      // 检查 PDF 查看器是否存在
      if (!this.$refs.pdfView) {
        return;
      }
      // 获取正确的页码
      const pageNumber = this.getPdfPageNumber(item.page);
      if (!pageNumber) {
        return;
      }

      // 先加载页面
      await this.$refs.pdfView.loadPage(pageNumber);
      // 等待页面渲染完成
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 500));

      // 获取 PDF 容器和页面数据
      const pdfView = this.$refs.pdfView;
      const container = pdfView.$refs && pdfView.$refs.pdfContainer;
      if (!container) {
        return;
      }

      // 如果有 position 信息，使用 scrollToHighlight
      if (Array.isArray(item.position) && item.position.length >= 4) {
        pdfView.scrollToHighlight({
          pageNumber,
          position: item.position
        });
      } else {
        // 如果没有 position，手动滚动到页面顶部
        // 通过 canvas-wrapper 的 id 来查找页面元素
        const pageIndex = pageNumber - 1;
        const canvasWrapper = document.getElementById('canvas-wrapper' + pageIndex);
        if (canvasWrapper) {
          await this.$nextTick();
          const rect = canvasWrapper.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const scrollTop = (rect.top - containerRect.top) + container.scrollTop;
          container.scrollTo({
            top: Math.max(0, scrollTop - 20), // 留一点顶部边距
            behavior: 'smooth'
          });
        }
      }
    },
    restoreImage(items,index){
      this.$confirm(this.$t('versionManage.subsection.confirmRestore'), this.$t('versionManage.subsection.restore'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.$set(items,'is_deleted',false)
        for (let i=0;i<this.split_paragraphs[index].original_paragraph.length;i++){
          if (this.split_paragraphs[index].original_paragraph[i].type === 'image' && this.split_paragraphs[index].original_paragraph[i].ocr_image_text){
            let indexStr = -1;
            let str = ""
            if (i > 0 && ((this.split_paragraphs[index].original_paragraph[i].id && (this.split_paragraphs[index].original_paragraph[i].id === items.id)) || this.split_paragraphs[index].original_paragraph[i].oss_image_url === items.oss_image_url)){
              str = this.split_paragraphs[index].original_paragraph[i - 1].text
            }
            if (this.split_paragraphs[index].original_paragraph[i].oss_image_url === items.oss_image_url){
              this.split_paragraphs[index].original_paragraph[i].is_deleted = false;
            }
            indexStr = this.split_paragraphs[index].paragraph.indexOf(str)
            if (indexStr !== -1 && this.split_paragraphs[index].paragraph){
              this.split_paragraphs[index].paragraph = this.split_paragraphs[index].paragraph.substring(0, indexStr + 1) + this.split_paragraphs[index].original_paragraph[i].text + this.split_paragraphs[index].paragraph.substring(indexStr + 1)
              this.editParagraphList[index].paragraph = this.editParagraphList[index].paragraph.substring(0, indexStr + 1) + this.split_paragraphs[index].original_paragraph[i].text + this.editParagraphList[index].paragraph.substring(indexStr + 1)
            }
          }
        }
        this.$message({
          message: this.$t('versionManage.subsection.restoreSuccess'),
          type:"success"
        })
      }).catch(() => {

      })
    },
    filterImages(images){
      return images.filter(item => !item.is_deleted)
    },
    identify(type){
      this.identifyMessage1 = '';
      this.identifyMessage2 = '';
      this.identifyType = type;
      if (type === 'img'){
        this.identifyMessage1 = this.$t('versionManage.subsection.confirmOcrAll');
        this.identifyMessage2 = this.$t('versionManage.subsection.ocrTip');
      } else {
        this.identifyMessage1 = this.$t('versionManage.subsection.confirmRestoreAll');
        this.identifyMessage2 = this.$t('versionManage.subsection.restoreAllTip');
      }
      this.ocrPopup = true;
    },
    confirmOcr(){
      // this.ocrPopup = false;
      this.hideBool = true;
      if (this.identifyType === 'img'){
        this.identifyMessage1 = this.$t('versionManage.subsection.ocrSplitting');
      } else {
        this.identifyMessage1 = this.$t('versionManage.subsection.restoreSplitting');
      }
      this.identifyMessage2 = this.$t('versionManage.subsection.operationTip');
    },
    ocrFun(item,index,type){
      if (this.checkStatus[this.ocrIndex] == undefined &&
          this.editParagraphList[this.ocrIndex] &&
          this.editParagraphList[this.ocrIndex].paragraph !== this.split_paragraphs[this.ocrIndex].paragraph){
        this.$confirm(this.$t('versionManage.subsection.sourceParagraph'), this.$t('versionManage.subsection.confirmTitle'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          this.checkStatus[this.ocrIndex] = true;
          this.ocrType = type;
          if (type === 'image'){
            this.ocrImage = item.oss_image_url;
            this.ocrId = item.id;
            this.ocrText = this.$t('versionManage.subsection.ocrImage');
          } else {
            this.ocrImage = item.oss_image_url;
            this.ocrId = item.id;
            this.ocrText = this.$t('versionManage.subsection.restoreImage');
          }
          this.ocrIndex = index;
          this.showOcrBtn = true;
          this.showPreview = true;
          this.editParagraphList[index].paragraph = this.split_paragraphs[index].paragraph;
          this.edit_paragraph[index] = false;
        }).catch(() => {
          this.checkStatus[this.ocrIndex] = undefined;
          this.split_paragraphs = JSON.parse(this.drop_split_paragraphs_copy);
        })
      } else {
        this.ocrType = type;
        if (type === 'image'){
          this.ocrImage = item.oss_image_url;
          this.ocrId = item.id;
          this.ocrText = this.$t('versionManage.subsection.ocrImage');
        } else {
          this.ocrImage = item.oss_image_url;
          this.ocrId = item.id;
          this.ocrText = this.$t('versionManage.subsection.restoreImage');
        }
        this.ocrIndex = index;
        this.showOcrBtn = true;
        this.showPreview = true;
      }

    },
    closeViewer(){
      this.showPreview = false;
    },
    identifyOcr(){
      this.loading = true;
      if (this.ocrType === 'image'){
        this.ocrText = this.$t('versionManage.subsection.recognizing');
        let url = '/ocr-api/document/ocr_recognition?document_id=' + this.$route.query.knowledgeId + '&oss_address=' + encodeURIComponent(this.ocrImage);
        this.$http.post(url).then(res => {
          let paragraph = ''
          if (res.data.status === 'success'){
            this.showPreview = false;
            this.loading = false;
            const hasParagraphs = Array.isArray(res.data.split_paragraphs) && res.data.split_paragraphs.length > 0;
            const hasTables = Array.isArray(res.data.tables) && res.data.tables.length > 0;
            if (hasParagraphs || hasTables){
                for (let i=0;i<res.data.split_paragraphs.length;i++){
                    let item = res.data.split_paragraphs[i];
                    paragraph += item.paragraph
                }
                this.ocr_image_text = paragraph;
                let str = '';
                let index = -1
                for (let k = 0; k < this.split_paragraphs[this.ocrIndex].original_paragraph.length; k++) {
                    let img = this.split_paragraphs[this.ocrIndex].original_paragraph[k];
                    if (img.type === 'image' && ((img.id && img.id === this.ocrId) || img.oss_image_url === this.ocrImage)) {
                        let original_paragraph = [];
                        for (let i = 0; i < res.data.split_paragraphs.length; i++) {
                            let new_original_paragraph = res.data.split_paragraphs[i].original_paragraph.map(item => {
                                let obj = {
                                    oss_image_url: img.oss_image_url,
                                    id: img.id,
                                    is_deleted: img.is_deleted,
                                    type: "image",
                                    ocr_image_text: res.data,
                                    text: item.text
                                };
                                return obj;
                            });
                            original_paragraph = original_paragraph.concat(new_original_paragraph);
                        }
                        if (hasTables) {
                          for (let i = 0; i < res.data.tables.length; i++) {
                            let table = res.data.tables.map(tab => {
                                let obj = {
                                    oss_image_url: img.oss_image_url,
                                    id: img.id,
                                    is_deleted: img.is_deleted,
                                    type: "image",
                                    ocr_image_text: res.data,
                                    text: tab.html
                                };
                                return obj;
                            });
                            original_paragraph = original_paragraph.concat(table);
                          }
                        }
                        // 保存插入元素的数量
                        let insertCount = original_paragraph.length;
                        // 删除一个元素
                        this.split_paragraphs[this.ocrIndex].original_paragraph.splice(k, 1);
                        // 插入多个元素
                        this.split_paragraphs[this.ocrIndex].original_paragraph.splice(k, 0, ...original_paragraph);
                        if (k === 0) {
                            str = this.split_paragraphs[this.ocrIndex].original_paragraph[k].text;
                        } else {
                            str = this.split_paragraphs[this.ocrIndex].original_paragraph[k - 1].text;
                        }
                        // 调整 k 的值，跳过插入的元素
                        k += insertCount - 1;
                    }
                    index = this.split_paragraphs[this.ocrIndex].paragraph.indexOf(str);
                }
              if (index !== -1 && this.split_paragraphs[this.ocrIndex].paragraph){
                let newIndex = index + str.length
                this.split_paragraphs[this.ocrIndex].paragraph = this.split_paragraphs[this.ocrIndex].paragraph.substring(0, newIndex + 1) + paragraph + this.split_paragraphs[this.ocrIndex].paragraph.substring(newIndex + 1)
                if (!this.editParagraphList[this.ocrIndex]){
                  this.$set(this.editParagraphList,this.ocrIndex,{paragraph:""})
                }
                this.editParagraphList[this.ocrIndex].paragraph = this.editParagraphList[this.ocrIndex].paragraph.substring(0, newIndex + 1) + paragraph + this.editParagraphList[this.ocrIndex].paragraph.substring(newIndex + 1)
              } else {
                this.split_paragraphs[this.ocrIndex].paragraph += paragraph;
                if (!this.editParagraphList[this.ocrIndex]){
                  this.$set(this.editParagraphList,this.ocrIndex,{paragraph:""})
                }
                this.editParagraphList[this.ocrIndex].paragraph += paragraph;
              }
              this.$message({
                message: this.$t('versionManage.subsection.ocrSuccess'),
                type:"success"
              })
            } else {
              this.$message({
                message: this.$t('versionManage.subsection.noRecognizableText'),
                type:"warning"
              });
              return;
            }
          } else {
            this.loading = false;
            this.showPreview = false;
            this.$message({
              message: this.$t('versionManage.subsection.recognizableFailText'),
              type:"warning"
            })
          }
        })
        .catch(() => {
          this.loading = false;
          this.showPreview = false;
          this.$message({
            message: this.$t('versionManage.subsection.recognizableFailText'),
            type:"warning"
          })
        })
      } else {
        this.ocrText = this.$t('versionManage.subsection.restoringAndSplitting');
        for (let i=0;i<this.split_paragraphs[this.ocrIndex].original_paragraph.length;i++){
          let item = this.split_paragraphs[this.ocrIndex].original_paragraph[i];
          if ((item.id && item.id == this.ocrId) || item.oss_image_url === this.ocrImage){
            this.ocr_image_text = item.text;
            item.ocr_image_text = ""
            item.text = "";
          }
        }
        this.split_paragraphs[this.ocrIndex].original_paragraph = this.split_paragraphs[this.ocrIndex].original_paragraph.filter((original,index,self) => {
          if (original.type === 'image'){
            return self.findIndex(t => (t.oss_image_url === original.oss_image_url)) === index;
          }
          return original
        })
        this.showPreview = false;
        this.loading = false;
        if (this.split_paragraphs[this.ocrIndex]){
          this.split_paragraphs[this.ocrIndex].paragraph = this.split_paragraphs[this.ocrIndex].paragraph.replace(this.ocr_image_text,"")
        }
        if (this.editParagraphList[this.ocrIndex]){
          this.editParagraphList[this.ocrIndex].paragraph = this.editParagraphList[this.ocrIndex].paragraph.replace(this.ocr_image_text,"")
        }
        this.$message({
          message: this.$t('versionManage.subsection.restoreComplete'),
          type:"success"
        })
      }
    },
    onImageClick(url){
      this.ocrImage = url;
      this.showPreview = true;
      this.showOcrBtn = false;
    },
    changeParagraphList(index){
      this.paragraph_reset[index] = false;
      this.edit_paragraph[index] = true;
    },
    changeTableDown(item,index){
      this.edit_paragraph[index] = true;
      this.edit_table[item.table_id] = true;
      this.setDownTable(item,'change');
    },
    changeTableParagraph(item){
      this.edit_table[item.table_id] = true;
    },
    getSignedImageUrl(url) {
      // 如果URL为空或不是OSS地址，直接返回
      if (!url || !url.includes('oss-cn-zhangjiakou.aliyuncs.com')) {
        return url;
      }
      
      // 如果URL已经有签名（包含Expires参数），直接返回
      if (url.includes('Expires=')) {
        return url;
      }
      
      // 检查缓存中是否已有签名URL
      if (this.imageSignatureCache && this.imageSignatureCache[url]) {
        return this.imageSignatureCache[url];
      }
      
      this.getImageSignature(url);
      
      // 临时返回原URL，等签名获取完成后再更新
      return url;
    },
    
    // 获取图片签名URL
    async getImageSignature(originalUrl) {
      try {
        
        const previewApi = requestUrl.preview.previewUrl + '?isVersionManage=1&needEncrypt=false';
        
        const resp = await this.$http.post(previewApi, { fileInOssPath: originalUrl });
        
        if (resp.data && resp.data.code === "0") {
          const signedUrl = resp.data.data;
          
          // 初始化缓存对象
          if (!this.imageSignatureCache) {
            this.$set(this, 'imageSignatureCache', {});
          }
          
          // 缓存签名URL
          this.$set(this.imageSignatureCache, originalUrl, signedUrl);
          
          
          // 强制更新视图
          this.$forceUpdate();
          
          // 使用nextTick确保DOM更新
          this.$nextTick(() => {
          });
          
        } else {
          console.error('图片签名失败:', resp.data);
        }
      } catch (err) {
        console.error('获取图片签名时出错:', err);
      }
    },
    
    // 生成图片的唯一key，用于强制重新渲染
    getImageKey(url) {
      if (!url) return 'no-url';
      
      // 如果有签名URL，使用签名URL作为key的一部分
      if (this.imageSignatureCache && this.imageSignatureCache[url]) {
        return url + '_signed_' + this.imageSignatureCache[url].substring(-20);
      }
      
      // 如果没有签名，使用原始URL和时间戳
      return url + '_' + Date.now();
    },
  },
  mounted() {
    const rawSuffix = (this.$route.query.fileSuffix || '').toLowerCase();
    const typeMap = {
      '飞书文档': 'feishuhtml'
    };
    this.fileSuffix = typeMap[rawSuffix] || rawSuffix;
    this.getParseInfo();
    
    // 添加页面离开时的警告处理
    this.handleBeforeUnload = (event) => {
      if (this.multiModalDirty) {
        const message = '当前多模态解析内容有未保存的改动，离开后将丢失，是否继续？';
        event.preventDefault();
        event.returnValue = message;
        return message;
      }
    };
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    
    // 添加调试方法到全局
    window.debugImageSignature = {
      // 查看当前缓存状态
      showCache: () => {
        return this.imageSignatureCache;
      },
      
      // 手动测试图片签名
      testSignature: (url) => {
        if (!url) {
          url = 'https://guoranwisdom.oss-cn-zhangjiakou.aliyuncs.com/ab0f90737c8b4f2d85ba2157e4473110/2025/08/18/17/23/57/68a2f127a03beb73db2551f3/image1.jpeg';
        }
        this.getImageSignature(url);
      },
      
      // 强制刷新所有图片
      refreshAllImages: () => {
        this.$forceUpdate();
      },
      
      // 查看组件实例
      getComponent: () => this
    };
  },
  beforeDestroy() {
    // 清理页面离开事件监听器
    if (this.handleBeforeUnload) {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
  },
};
</script>

<style scoped lang="less">
.subsection{
  height: 100%;
  width: calc(100% - 40px);
  display: flex;
  box-sizing: border-box;
  background: #ffffff;
  .subsectionLeft{
    width: 50%;
    flex: none;
    border-right: 1px solid #E0E6F7;
    padding: 16px;
    box-sizing: border-box;
    overflow-y: scroll;
    div{
      position: relative;
    }
    ///deep/div:hover{
    //  background: #F4F6FB!important;
    //}
    .leftParagraphItem:hover{
      background: #F4F6FB!important;
      cursor: pointer;
    }
    /deep/img{
      max-width: 100%;
    }
    
    // 音频容器样式
    .audioContainer{
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      
      .audioPlayer{
        width: 100%;
        padding: 20px 0;
        background: #f8f9fc;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        
        audio{
          width: 90%;
          max-width: 600px;
          outline: none;
          
          &::-webkit-media-controls-panel{
            background-color: #fff;
          }
        }
      }
      
      .audioContent{
        flex: 1;
        overflow-y: auto;
        padding-top: 10px;
      }
    }
  }
  .subsectionPdfLeft{
    width: 50%;
    flex: none;
    border-right: 1px solid #E0E6F7;
    padding: 16px;
    box-sizing: border-box;
    div{
      position: relative;
    }
    ///deep/div:hover{
    //  background: #F4F6FB!important;
    //}
    .leftParagraphItem:hover{
      background: #F4F6FB!important;
      cursor: pointer;
    }
    /deep/img{
      max-width: 100%;
    }
  }
  .subsectionRight{
    width: 50%;
    flex: none;
    padding: 16px;
    box-sizing: border-box;
    height: 100%;
    .rightHeader{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      .custom-tabs{
        flex: 1;
        /deep/ .el-tabs__header{
          margin: 0;
          border-bottom: none;
        }
        /deep/ .el-tabs__nav-wrap::after{
          display: none;
        }
        /deep/ .el-tabs__item{
          padding: 0 16px;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          color: #666666;
          border: none;
          .tab-number{
            display: inline-block;
            height: 20px;
            padding: 0 6px;
            background: #ECF1FF;
            border-radius: 10px;
            color: #366AFF;
            font-size: 12px;
            margin-left: 6px;
            line-height: 20px;
          }
          &.is-active{
            color: #366aff;
            font-weight: 500;
            .tab-number{
              background: #E3EBFF;
            }
          }
          &:hover{
            color: #366aff;
          }
        }
        /deep/ .el-tabs__active-bar{
          background-color: #366aff;
        }
      }
      .headerRight{
        display: flex;
        align-items: center;
        .ocrBtn{
          height: 28px;
          padding: 0 8px;
          background: #FFFFFF;
          border-radius: 15px;
          border: 1px solid #A1B9FF;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #366aff;
          cursor: pointer;
          font-size: 12px;
          margin-right: 10px;
          i{
            font-size: 12px;
          }
          .guoran-tongyichicun-shibieshuai{
            margin-right: 4px;
          }
          .el-icon-arrow-down{
            margin-left: 4px;
          }
        }
        .sort{
          display: flex;
          align-items: center;
          margin-right: 10px;
          font-size: 12px;
          .sortTitle{
            display: flex;
            align-items: center;
            margin-right: 6px;
            .guoran-bangzhuzhongxin{
              margin-left: 4px;
              font-size: 12px;
            }
          }
        }
        .openBtn{
          height: 28px;
          padding: 0 8px;
          background: #FFFFFF;
          border-radius: 15px;
          border: 1px solid #A1B9FF;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #366aff;
          cursor: pointer;
          font-size: 12px;
          i{
            margin-right: 4px;
            font-size: 12px;
          }
        }
        .closeBtn{
          height: 28px;
          padding: 0 8px;
          background: #FFFFFF;
          border-radius: 15px;
          border: 1px solid #A1B9FF;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #366aff;
          cursor: pointer;
          margin: 0 10px;
          font-size: 12px;
          i{
            margin-right: 4px;
            font-size: 12px;
          }
        }
        .saveBtn{
          height: 28px;
          padding: 0 8px;
          background: #366aff;
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          cursor: pointer;
          font-size: 12px;
          i{
            margin-right: 4px;
            font-size: 12px;
          }
        }
      }
    }
    .splitParagraphs{
      height: calc(100% - 50px);
      overflow-y: scroll;
      padding-right: 10px;
      
      .paragraphItem{
        background: #F6F8FD;
        border-radius: 5px;
        padding: 8px 12px;
        margin-bottom: 12px;
        border: 1px solid #ffffff;
        .paragraphTitle{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .titleLeft{
            display: flex;
            align-items: center;
            overflow: hidden;
            .title{
              display: flex;
              align-items: center;
              flex: none;
              height: 21px;
              padding: 0 4px;
              background: #E3EBFF;
              margin-right: 8px;
            }
            .prompt{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .titleRight{
            display: flex;
            align-items: center;
            i{
              color: #366aff;
              cursor: pointer;
              margin-left: 14px;
              font-size: 14px;
            }
          }

        }
        .paragraphContainer{
          padding-top: 12px;
          .paragraph{
            margin-bottom: 4px;
            .text{
              word-break: break-all;
              overflow-wrap: anywhere;
              white-space: pre-wrap;
            }
          }
          .editParagraph{
            border: 1px solid #E0E6F7;
            border-radius: 5px;
            .editHeader{
              padding: 8px 12px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              .headerRight{
                display: flex;
                align-items: center;
                width: 100%;
                justify-content: flex-end;
              }
              .guoran-tongyichicun-kaiqi1{
                margin: 0 10px;
                color: #366aff;
              }
              i{
                cursor:pointer;
                font-size: 14px;
                color: #999999;
              }
            }
            .editContainer{
              .tableHeader{
                display: flex;
                align-items: center;
                height: 40px;
                padding: 0 10px;
                background-color: #F0F4FF;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                .tableHeaderTip{
                  margin-left: 6px;
                  font-size: 12px;
                  color: #616161;
                }
              }
            }
            .tableContainer{
              position: relative;
              .tablePopover{
                position: fixed;
                left: calc(50% - 370px);
                width: 400px;
                height: 400px;
                top: 0;
                z-index: 99;
                background-color: #ffffff;
              }
            }
            /deep/.el-textarea__inner{
              border: none;
            }
          }
          .originalParagraphs{
            background: #E3EBFF;
            border-radius: 5px;
            padding: 12px;
            margin-top: 12px;
            .originalTitle{
              margin-bottom: 12px;
              display: flex;
              align-items: center;
              .originalTip{
                color: #999999;
                font-size: 12px;
                margin-left: 6px;
              }
            }
            .originalParagraphItem{
              background: #F6F8FD;
              border-radius: 5px;
              padding: 6px;
              display: flex;
              justify-content: space-between;
              margin-bottom: 6px;
              border: 1px solid #F6F8FD;
              .originalLeft{
                display: flex;
                flex: 1;
                min-width: 0;
                .originalText{
                  word-break: break-all;
                  overflow-wrap: anywhere;
                  white-space: pre-wrap;
                }
                .ocr_text{
                  display: flex;
                  align-items: center;
                  cursor: pointer;
                  min-width: 0;
                  .ocr_image_thumbnail{
                    flex: none;
                    margin-right: 10px;
                    .el-image{
                      border-radius: 4px;
                      overflow: hidden;
                    }
                  }
                  .ocr_content{
                    display: flex;
                    flex-direction: column;
                  }
                  .ocr_icon{
                    font-size: 12px;
                    width: 80px;
                    flex: none;
                  }
                  .ocr_image_text{
                    word-break: break-all;
                    overflow-wrap: anywhere;
                    white-space: pre-wrap;
                    color: #333;
                  }
                }
              }
              .guoran-tuodong{
                color: #366aff;
                margin-right: 6px;
                cursor: move;
                display: none;
              }
              .originalRight{
                display: none;
                .ocrIcon{
                  margin-left: 10px;
                  i{
                    //color: #366aff;
                    cursor:pointer;
                    font-size: 14px;
                  }
                  .guoran-OCR{
                    color: #366aff;
                  }
                }
                .delete_icon{
                  flex: none;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 0 6px;
                  height: 20px;
                  background: #E4ECFF;
                  border-radius: 9px;
                  font-size: 12px;
                  color: #666666;
                  margin-left: 10px;
                }
              }
              .guoran-qita1{
                color: #366aff;
                margin-left: 12px;
                cursor: pointer;
              }
              /deep/td{
                border: 1pt solid #E0E6F7!important;
              }
              /deep/table{
                background: #ffffff;
                border: 1pt solid #E0E6F7!important;
              }
            }

            .originalParagraphItem:hover{
              border: 1px solid #A1B9FF;
              .guoran-tuodong{
                display: flex;
              }
              .originalRight{
                display: flex;
              }
              .guoran-qita1{
                display: flex;
              }
            }
          }
          /deep/.el-table__empty-text{
            line-height: 20px!important;
          }
        }
      }
    }
    // 多模态解析部分样式
    .multiModalSection{
      height: calc(100% - 50px);
      overflow-y: scroll;
      padding-right: 10px;  
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #E0E6F7;
        .multiModalTitle{
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          span{
            font-size: 14px;
            font-weight: 500;
            color: #000000;
            margin-right: 8px;
          }
          .number{
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            background: #E3EBFF;
            border-radius: 10px;
            font-size: 12px;
            color: #366aff;
          }
        }
        .multiModalList{
          .multiModalItem{
            background: #F6F8FD;
            border-radius: 5px;
            padding: 12px;
            margin-bottom: 12px;
            border: 1px solid #ffffff;
            cursor: default;
            .multiModalContent{
              display: flex;
              gap: 12px;
              .multiModalImage{
                flex: none;
                position: relative;
                width: 120px;
                height: 120px;
                /deep/ .el-image{
                  width: 120px;
                  height: 120px;
                  border-radius: 4px;
                  overflow: hidden;
                  img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }
                .imagePage{
                  position: absolute;
                  bottom: 4px;
                  left: 4px;
                  background: rgba(0, 0, 0, 0.6);
                  color: #ffffff;
                  padding: 2px 6px;
                  border-radius: 2px;
                  font-size: 11px;
                  z-index: 1;
                }
                .image-slot{
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 120px;
                  height: 120px;
                  background: #f5f7fa;
                  color: #909399;
                  font-size: 30px;
                  border-radius: 4px;
                }
              }
              .multiModalText{
                flex: 1;
                display: flex;
                flex-direction: column;
                min-width: 0;
                .textContent{
                  flex: 1;
                  padding: 8px 12px;
                  background: #ffffff;
                  border-radius: 4px;
                  min-height: 100px;
                  line-height: 1.6;
                  color: #333333;
                  font-size: 13px;
                  word-break: break-word;
                  white-space: pre-wrap;
                  cursor: pointer;
                  user-select: none;
                  transition: background-color 0.2s;
                  position: relative;
                  &:hover{
                    background: #f5f7fa;
                    .textActions{
                      opacity: 1;
                      visibility: visible;
                    }
                  }
                  &:active{
                    background: #eef0f5;
                  }
                }
                .textActions{
                  position: absolute;
                  top: 8px;
                  right: 8px;
                  display: flex;
                  gap: 8px;
                  opacity: 0;
                  visibility: hidden;
                  transition: opacity 0.2s, visibility 0.2s;
                  background: rgba(255, 255, 255, 0.9);
                  padding: 4px 8px;
                  border-radius: 4px;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                  z-index: 10;
                  i{
                    color: #366aff;
                    cursor: pointer;
                    font-size: 16px;
                    padding: 4px;
                    transition: color 0.2s;
                    &:hover{
                      color: #2952cc;
                    }
                    &:active{
                      color: #1e3d99;
                    }
                  }
                }
                .editContainer{
                  width: 100%;
                  /deep/ .el-textarea{
                    .el-textarea__inner{
                      font-size: 13px;
                      line-height: 1.6;
                    }
                  }
                  .editActions{
                    display: flex;
                    justify-content: flex-end;
                    gap: 8px;
                    margin-top: 8px;
                  }
                }
              }
            }
          }
        }
      }
    .loading{
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/img{
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
  .orcTips{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #616161;
    .tip1{
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      img{
        margin-right: 6px;
        width: 20px;
        height: 20px;
      }
    }
  }
}
.animation {
  animation-name: highlight;
  animation-duration: 4s;
}
.popoverContainer{
  .popoverBtn{
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    .same{
      border-radius: 10px;
      padding: 0px 6px;
      height: 24px;
      font-size: 12px;
      cursor:pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cancel{
      border: 1px solid #366aff;
      color: #366aff;
      background-color: #ffffff;
      margin-right: 6px;
    }
    .confirm{
      border: 1px solid #366aff;
      background-color: #366aff;
      color: #ffffff;
    }
  }
}
@keyframes highlight {
  0% {
    background: rgba(255, 136, 0, 0.3);
  }

  25% {
    background: rgba(255, 136, 0, 0.6);
  }

  50% {
    background: rgba(255, 136, 0, 0.3);
  }

  75% {
    background: rgba(255, 136, 0, 0.6);
  }

  100% {
    background: rgba(255, 136, 0, 0.3);
  }
}

.upload-area {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color .3s;
}
.upload-area:hover {
  border-color: #409EFF;
}
.upload-placeholder {
  text-align: center;
  color: #8c939d;
}
.upload-placeholder i {
  font-size: 28px;
  margin-bottom: 10px;
}
.preview-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}
.preview-img {
  max-width: 100%;
  max-height: 100%;
}
.preview-actions {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview-container:hover .preview-actions {
  opacity: 1;
}
.preview-actions i {
  cursor: pointer;
}
</style>
